import { default_header, default_header_example } from './defaultData';
import { apiParamDesc } from './docHelpers';

const data = (userInfo) => ({
  title: '상품 (Hmall)',
  children: [
    {
      title: '상품리스트 조회',
      url: '/doc/Hmall/상품리스트 조회',
      data: [
        {
          version: 'hmall',
          url: '/product/online/list/hmall',
          desc: (
            <div>
              <ul className='style'>
                <li>상품 {'>'} 상품 관리 리스트를 가져옵니다.</li>
                <li>기본 검색은 하나의 검색어만 지원가능합니다.</li>
                <li>
                  여러건의 검색을 원하시는경우 멀티검색(multi_search_word)을
                  이용해 주십시오.
                </li>
              </ul>
            </div>
          ),
          method: 'POST',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'start',
              required: '',
              type: 'Number',
              desc: '검색 시작 값',
            },
            {
              title: 'length',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  조회할 상품 갯수
                  <div className='description'>
                    Max value:{' '}
                    <strong>
                      <code>1000</code>
                    </strong>
                  </div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>100</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'orderby',
              required: '',
              type: 'String',
              desc: '정렬',
            },
            {
              title: 'search_key',
              required: '',
              type: 'String',
              desc: (
                <div>
                  검색 키
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_sale_name</code>
                          </strong>
                        </td>
                        <td>
                          <strong>온라인 상품명</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>c_sale_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>판매자관리코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_sale_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>쇼핑몰 상품코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>brand</code>
                          </strong>
                        </td>
                        <td>
                          <strong>브랜드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>model</code>
                          </strong>
                        </td>
                        <td>
                          <strong>모델명</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>barcode</code>
                          </strong>
                        </td>
                        <td>
                          <strong>바코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>global_barcode</code>
                          </strong>
                        </td>
                        <td>
                          <strong>UPC,EAN 코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>isbn</code>
                          </strong>
                        </td>
                        <td>
                          <strong>ISBN코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>keyword</code>
                          </strong>
                        </td>
                        <td>
                          <strong>키워드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>memo</code>
                          </strong>
                        </td>
                        <td>
                          <strong>메모</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>std_ol_group_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>그룹상품코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_promotion_name</code>
                          </strong>
                        </td>
                        <td>
                          <strong>프로모션용 상품명</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <strong>
                    <ul className='style'>
                      <li>
                        <code>값을 넣지않는경우 전체검색됩니다.</code>
                      </li>
                    </ul>
                  </strong>
                </div>
              ),
            },
            {
              title: 'search_word',
              required: '',
              type: 'String',
              desc: '검색어',
            },
            {
              title: 'search_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  검색타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>partial</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>exact</code>
                          </strong>
                        </td>
                        <td>
                          <strong>완전일치</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>partial</code>
                          </strong>
                        </td>
                        <td>
                          <strong>부분일치</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'date_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  검색타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>wdate</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>wdate</code>
                          </strong>
                        </td>
                        <td>
                          <strong>등록일</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>mdate</code>
                          </strong>
                        </td>
                        <td>
                          <strong>수정일</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>sale_etime</code>
                          </strong>
                        </td>
                        <td>
                          <strong>판매종료일</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'sdate',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  검색시작일
                  <div className='description'>(YYYY-MM-DD)</div>
                </div>
              ),
            },
            {
              title: 'edate',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  검색종료일
                  <div className='description'>(YYYY-MM-DD)</div>
                </div>
              ),
            },
            {
              title: 'opt_yn',
              required: '',
              type: 'String',
              desc: (
                <div>
                  옵션 사용여부
                  <div className='description'>
                    ["Y: 옵션이 있는 상품만 조회", "N": 옵션이 없는 상품만
                    조회"]
                  </div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <strong>
                    <ul className='style'>
                      <li>
                        <code>값을 넣지않는경우 전체검색됩니다.</code>
                      </li>
                    </ul>
                  </strong>
                </div>
              ),
            },
            {
              title: 'shop_cd',
              required: '',
              type: 'String',
              desc: (
                <div>
                  쇼핑몰코드
                  <div className='description'>
                    ( 토스 쇼핑: A538, 베네피아: B513, 카페24(신): B616,
                    지그재그-포스티: P018 )
                  </div>
                </div>
              ),
            },
            {
              title: 'template_no',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  템플릿 번호
                  <ul style={{ color: 'gray' }}>
                    <li>해당 템플릿이 적용된 온라인상품을 검색합니다.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'sale_status',
              required: '',
              type: 'Array',
              desc: (
                <div>
                  상품 판매 상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>판매대기</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>승인대기</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>반려</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>판매중</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>종료대기</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>수정대기</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>판매중지</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>일시품절</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'opt_status',
              required: '',
              type: 'String',
              desc: (
                <div>
                  옵션 상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>정상</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>품절</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'multi_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  멀티검색 키
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>c_sale_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>판매자관리코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_sale_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>쇼핑몰상품코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>sku_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>SKU코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop</code>
                          </strong>
                        </td>
                        <td>
                          <strong>쇼핑몰아이디</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'multi_search_word',
              required: '',
              type: 'String[]',
              desc: (
                <div>
                  멀티검색 값
                  <div className='description'>
                    <br />
                    multi_type이 shop인 경우에는 다음과 같이 설정합니다.
                    <div>
                      (shop_cd|shop_id): ["A538|playauto", "B616|playauto"]
                    </div>
                  </div>
                </div>
              ),
            },
          ],
          body_example: {
            start: 0,
            length: 100,
            sdate: '2026-01-01',
            edate: '2026-01-20',
            date_type: 'wdate',
            search_key: 'all',
            search_type: 'partial',
            search_word: '',
            orderby: 'wdate desc',
            template_no: 2252130,
            sale_status: ['판매중'],
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Object',
              desc: '검색결과는 판매자관리코드로 그룹화되어 판매자관리코드를 키로 가진 배열로 출력됩니다.',
            },
            {
              title: 'sol_no',
              required: 'O',
              type: 'Number(8)',
              desc: '솔루션번호',
              indent: 1,
            },
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'Number(10)',
              desc: '상품고유값',
              indent: 1,
            },
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String(40)',
              desc: '판매자관리코드',
              indent: 1,
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String(4)',
              desc: '쇼핑몰 코드',
              indent: 1,
            },
            {
              title: 'shop_name',
              required: 'O',
              type: 'String(50)',
              desc: '쇼핑몰 명',
              indent: 1,
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String(40)',
              desc: '쇼핑몰 계정 아이디',
              indent: 1,
            },
            {
              title: 'shop_sale_name',
              required: 'O',
              type: 'String(200)',
              desc: '쇼핑몰상품명',
              indent: 1,
            },
            {
              title: 'sale_status',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  상품 판매 상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>판매대기</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>승인대기</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>반려</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>판매중</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>종료대기</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>수정대기</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>판매중지</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>일시품절</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'sale_cnt_limit',
              required: 'O',
              type: 'Number(10)',
              desc: '판매수량',
              indent: 1,
            },
            {
              title: 'sale_price',
              required: 'O',
              type: 'Number(12)',
              desc: '상품 금액',
              indent: 1,
            },
            {
              title: 'cost_price',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  상품 원가
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'supply_price',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  공급가
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'street_price',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  시중가
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'opt_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  옵션 타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>옵션없음</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>조합형</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'input_opt_names',
              required: 'O',
              type: 'String[]',
              desc: '입력형옵션',
              indent: 1,
            },
            {
              title: 'tax_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  과세여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>과세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>면세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>영세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>비과세</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'ship_price_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  배송비 종류
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>무료</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>조건부무료</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>착불</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>선결제</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'ship_price',
              required: 'O',
              type: 'Number(8)',
              desc: '배송비 금액',
              indent: 1,
            },
            {
              title: 'ship_carr_no',
              required: 'O',
              type: 'Number(8)',
              desc: '배송 택배사코드',
              indent: 1,
            },
            {
              title: 'ship_leadtime',
              required: 'O',
              type: 'Number(8)',
              desc: '배송 소요일',
              indent: 1,
            },
            {
              title: 'prod_condition',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  상품 상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>new</code>
                          </strong>
                        </td>
                        <td>신상품</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>used</code>
                          </strong>
                        </td>
                        <td>중고상품</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'bundle_ship_avail_yn',
              required: 'O',
              type: 'Boolean',
              desc: '묶음배송 가능 여부',
              indent: 1,
            },
            {
              title: 'min_sale_qty_yn',
              required: 'O',
              type: 'Boolean',
              desc: '최소 구매수량 사용 여부',
              indent: 1,
            },
            {
              title: 'min_sale_qty',
              required: '',
              type: 'Number(8)',
              desc: '최소 구매수량',
              indent: 1,
            },
            {
              title: 'max_sale_qty_yn',
              required: 'O',
              type: 'Boolean',
              desc: '최대 구매수량 사용 여부',
              indent: 1,
            },
            {
              title: 'max_sale_qty',
              required: '',
              type: 'Number(8)',
              desc: '최대 구매수량',
              indent: 1,
            },
            {
              title: 'max_sale_qty_creteria',
              required: '',
              type: 'String',
              desc: (
                <div>
                  최대 구매수량 타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>person</code>
                          </strong>
                        </td>
                        <td>구매자별 '수량 제한'</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>ord</code>
                          </strong>
                        </td>
                        <td>주문별 '1회 제한'</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'shop_sale_no',
              required: 'O',
              type: 'String(40)',
              desc: '쇼핑몰 판매번호',
              indent: 1,
            },
            {
              title: 'sale_img1',
              required: 'O',
              type: 'String(230)',
              desc: '기본이미지',
              indent: 1,
            },
            {
              title: 'sale_img2',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 1',
              indent: 1,
            },
            {
              title: 'sale_img3',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 2',
              indent: 1,
            },
            {
              title: 'sale_img4',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 3',
              indent: 1,
            },
            {
              title: 'sale_img5',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 4',
              indent: 1,
            },
            {
              title: 'sale_img6',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 5',
              indent: 1,
            },
            {
              title: 'sale_img7',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 6',
              indent: 1,
            },
            {
              title: 'sale_img8',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 7',
              indent: 1,
            },
            {
              title: 'sale_img9',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 8',
              indent: 1,
            },
            {
              title: 'sale_img10',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 9',
              indent: 1,
            },
            {
              title: 'sale_img11',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 10',
              indent: 1,
            },
            {
              title: 'detail_desc',
              required: 'O',
              type: 'String(16777215)',
              desc: '상품 상세설명',
              indent: 1,
            },
            {
              title: 'keywords',
              required: 'O',
              type: 'String[]',
              desc: '키워드',
              indent: 1,
            },
            {
              title: 'model',
              required: 'O',
              type: 'String(50)',
              desc: '모델명',
              indent: 1,
            },
            {
              title: 'model_no',
              required: 'O',
              type: 'String(50)',
              desc: '모델 번호',
              indent: 1,
            },
            {
              title: 'brand',
              required: 'O',
              type: 'String(50)',
              desc: '브랜드',
              indent: 1,
            },
            {
              title: 'maker',
              required: 'O',
              type: 'String(50)',
              desc: '제조사',
              indent: 1,
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  상품등록일
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'mdate',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  상품수정일
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'std_ol_yn',
              required: 'O',
              type: 'Number(1)',
              desc: (
                <div>
                  단일상품 여부
                  <div className='description'>(0: 일반상품, 1: 단일상품)</div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'template_no',
              required: 'O',
              type: 'Number',
              desc: '쇼핑몰 템플릿 번호',
              indent: 1,
            },
            {
              title: 'shop_cate_info',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 카테고리 정보',
              indent: 1,
            },
            {
              title: 'opts',
              required: 'O',
              type: 'Object[]',
              desc: <div>옵션</div>,
              indent: 1,
            },
            {
              title: 'model_no',
              required: 'O',
              type: 'String(50)',
              desc: (
                <div>
                  Hmall 옵션 관리코드
                  <div className='description'>
                    (속성코드번호 + 옵션품목코드)
                  </div>
                </div>
              ),
              indent: 2,
            },
            {
              title: 'sale_opt_seq',
              required: 'O',
              type: 'Number(5)',
              desc: '옵션순번',
              indent: 2,
            },
            {
              title: 'deal_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  옵션타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>일반</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 2,
            },
            {
              title: 'opt_sort1',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 1',
              indent: 2,
            },
            {
              title: 'opt_sort2',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 2',
              indent: 2,
            },
            {
              title: 'opt_sort3',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 3',
              indent: 2,
            },
            {
              title: 'opt_name1',
              required: 'O',
              type: 'String(80)',
              desc: '옵션값 1',
              indent: 2,
            },
            {
              title: 'opt_name2',
              required: 'O',
              type: 'String(80)',
              desc: (
                <div>
                  옵션값2
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 2,
            },
            {
              title: 'opt_name3',
              required: 'O',
              type: 'String(80)',
              desc: (
                <div>
                  옵션값3
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 2,
            },
            {
              title: 'add_price',
              required: 'O',
              type: 'Number(9)',
              desc: (
                <div>
                  옵션 추가금액
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 2,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Number(9)',
              desc: '옵션수량',
              indent: 2,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  옵션상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>정상</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>품절</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 2,
            },
            {
              title: 'prod_info',
              required: 'O',
              type: 'Object',
              desc: (
                <div>
                  상품정보제공고시
                  <div className='description'>
                    상품분류코드에 따라 infoDetail 안에 키 값이 달라질 수
                    있습니다.
                  </div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'infoCode',
              required: 'O',
              type: 'String',
              desc: '상품분류코드',
              indent: 2,
            },
            {
              title: 'infoName',
              required: 'O',
              type: 'String',
              desc: '상품분류명',
              indent: 2,
            },
            {
              title: 'infoDetail',
              required: 'O',
              type: 'String',
              desc: '상품정보제공고시 데이터',
              indent: 2,
            },
            {
              title: 'ol_count',
              required: 'O',
              type: 'Number',
              desc: '검색된 마스터상품 수',
            },
            {
              title: 'normal_count',
              required: 'O',
              type: 'Number',
              desc: '검색된 일반상품 수',
            },
            {
              title: 'single_count',
              required: 'O',
              type: 'Number',
              desc: '검색된 단일상품 수',
            },
          ],
          response_example: {
            results: {
              m2022060881c9e7f86: [
                {
                  sol_no: 640,
                  ol_shop_no: 69224644,
                  c_sale_cd: 'm2022060881c9e7f86',
                  shop_cd: 'Z000',
                  shop_name: '마스터 온라인상품',
                  shop_id: '',
                  shop_sale_name: '테스트 온라인 상품',
                  sale_status: '',
                  sale_cnt_limit: 99,
                  sale_price: 10000,
                  cost_price: 0,
                  supply_price: 0,
                  street_price: 0,
                  opt_type: '조합형',
                  input_opt_names: [],
                  tax_type: '과세',
                  ship_price_type: '무료',
                  ship_price: 0,
                  ship_carr_no: 4,
                  ship_leadtime: 2,
                  prod_condition: 'new',
                  bundle_ship_avail_yn: true,
                  min_sale_qty_yn: false,
                  max_sale_qty_yn: false,
                  shop_sale_no: null,
                  sale_img1:
                    'https://s3-ap-northeast-2.amazonaws.com/gmp01/640/online/26070990/Z000/202111041549441.jpg',
                  sale_img2: '',
                  sale_img3: '',
                  sale_img4: '',
                  sale_img5: '',
                  sale_img6: '',
                  sale_img7: '',
                  sale_img8: '',
                  sale_img9: '',
                  sale_img10: '',
                  sale_img11: '',
                  detail_desc: '상세설명',
                  keywords: [],
                  model: '',
                  model_no: '',
                  brand: '',
                  maker: '',
                  wdate: '2026-01-21 12:34:17',
                  mdate: '2026-01-21 12:34:17',
                  std_ol_yn: 0,
                  template_no: 0,
                  shop_cate_info: '',
                  opts: [
                    {
                      model_no: '00001-00001',
                      sale_opt_seq: 1,
                      deal_type: '일반',
                      opt_sort1: '색상',
                      opt_sort2: '사이즈',
                      opt_sort3: '',
                      opt_name1: '블랙',
                      opt_name2: 'L',
                      opt_name3: '',
                      add_price: 0,
                      stock_cnt: 77,
                      status: '정상',
                    },
                    {
                      model_no: '00002-00001',
                      sale_opt_seq: 2,
                      deal_type: '일반',
                      opt_sort1: '색상',
                      opt_sort2: '사이즈',
                      opt_sort3: '',
                      opt_name1: '하늘',
                      opt_name2: 'L',
                      opt_name3: '',
                      add_price: 0,
                      stock_cnt: 66,
                      status: '정상',
                    },
                    {
                      model_no: '00001-00002',
                      sale_opt_seq: 1,
                      deal_type: '일반',
                      opt_sort1: '색상',
                      opt_sort2: '사이즈',
                      opt_sort3: '',
                      opt_name1: '블랙',
                      opt_name2: 'S',
                      opt_name3: '',
                      add_price: 0,
                      stock_cnt: 77,
                      status: '정상',
                    },
                    {
                      model_no: '00002-00002',
                      sale_opt_seq: 2,
                      deal_type: '일반',
                      opt_sort1: '색상',
                      opt_sort2: '사이즈',
                      opt_sort3: '',
                      opt_name1: '하늘',
                      opt_name2: 'S',
                      opt_name3: '',
                      add_price: 0,
                      stock_cnt: 66,
                      status: '정상',
                    },
                  ],
                  prod_info: {
                    infoCode: 'Wear2023',
                    infoName: '의류',
                    infoDetail: {
                      material: '1',
                      color: '2',
                      size: '3',
                      manufacturer: '4',
                      made_in: '5',
                      caution: '6',
                      release: '7',
                      warranty: '8',
                      customer_service: '9',
                    },
                  },
                },
                {
                  sol_no: 640,
                  ol_shop_no: 69224645,
                  c_sale_cd: 'm2022060881c9e7f86',
                  shop_cd: 'B616',
                  shop_name: '카페24(신)',
                  shop_id: 'testcafe24',
                  shop_sale_name: '테스트 온라인 상품',
                  sale_status: '판매중',
                  sale_cnt_limit: 99,
                  sale_price: 10000,
                  cost_price: 0,
                  supply_price: 0,
                  street_price: 0,
                  opt_type: '조합형',
                  input_opt_names: [],
                  tax_type: '과세',
                  ship_price_type: '무료',
                  ship_price: 0,
                  ship_carr_no: 4,
                  ship_leadtime: 2,
                  prod_condition: 'new',
                  bundle_ship_avail_yn: true,
                  min_sale_qty_yn: false,
                  max_sale_qty_yn: true,
                  max_sale_qty: 1,
                  max_sale_qty_creteria: 'person',
                  shop_sale_no: '123123',
                  sale_img1:
                    'https://s3-ap-northeast-2.amazonaws.com/gmp01/640/online/26070990/Z000/202111041549441.jpg',
                  sale_img2: '',
                  sale_img3: '',
                  sale_img4: '',
                  sale_img5: '',
                  sale_img6: '',
                  sale_img7: '',
                  sale_img8: '',
                  sale_img9: '',
                  sale_img10: '',
                  sale_img11: '',
                  detail_desc: '상세설명',
                  keywords: [],
                  model: '모델명',
                  model_no: '',
                  brand: '브랜드',
                  maker: '제조사',
                  wdate: '2026-01-21 12:34:17',
                  mdate: '2026-01-21 12:34:17',
                  std_ol_yn: 0,
                  template_no: 2252130,
                  shop_cate_info: '(대분류) Outerwear > (중분류) Jackets',
                  opts: [
                    {
                      model_no: '00001-00001',
                      sale_opt_seq: 1,
                      deal_type: '일반',
                      opt_sort1: '색상',
                      opt_sort2: '사이즈',
                      opt_sort3: '',
                      opt_sort1_desc: '블랙',
                      opt_sort2_desc: 'L',
                      opt_sort3_desc: '',
                      add_price: 0,
                      stock_cnt: 77,
                      status: '정상',
                    },
                    {
                      model_no: '00002-00001',
                      sale_opt_seq: 2,
                      deal_type: '일반',
                      opt_sort1: '색상',
                      opt_sort2: '사이즈',
                      opt_sort3: '',
                      opt_name1: '하늘',
                      opt_name2: 'L',
                      opt_name3: '',
                      add_price: 0,
                      stock_cnt: 66,
                      status: '정상',
                    },
                    {
                      model_no: '00001-00002',
                      sale_opt_seq: 1,
                      deal_type: '일반',
                      opt_sort1: '색상',
                      opt_sort2: '사이즈',
                      opt_sort3: '',
                      opt_name1: '블랙',
                      opt_name2: 'S',
                      opt_name3: '',
                      add_price: 0,
                      stock_cnt: 77,
                      status: '정상',
                    },
                    {
                      model_no: '00002-00002',
                      sale_opt_seq: 2,
                      deal_type: '일반',
                      opt_sort1: '색상',
                      opt_sort2: '사이즈',
                      opt_sort3: '',
                      opt_name1: '하늘',
                      opt_name2: 'S',
                      opt_name3: '',
                      add_price: 0,
                      stock_cnt: 66,
                      status: '정상',
                    },
                  ],
                  prod_info: {
                    infoCode: 'Wear2023',
                    infoName: '의류',
                    infoDetail: {
                      material: '1',
                      color: '2',
                      size: '3',
                      manufacturer: '4',
                      made_in: '5',
                      caution: '6',
                      release: '7',
                      warranty: '8',
                      customer_service: '9',
                    },
                  },
                },
              ],
            },
            ol_count: 1,
            normal_count: 1,
            single_count: 0,
          },
        },
      ],
    },
    {
      title: '온라인상품 상세 조회',
      url: '/doc/Hmall/온라인상품 상세 조회',
      data: [
        {
          version: 'hmall',
          url: '/product/:ol_shop_no/hmall',
          desc: '사용중인 솔루션에 등록된 온라인상품 정보를 조회합니다.',
          method: 'GET',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'Number(10)',
              desc: '온라인상품 고유번호',
            },
          ],
          response: [
            {
              title: 'sol_no',
              required: 'O',
              type: 'Number(8)',
              desc: '솔루션번호',
            },
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'Number(10)',
              desc: '온라인상품 고유번호',
            },
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String(40)',
              desc: '판매자관리코드',
            },
            {
              title: 'sale_no',
              required: 'O',
              type: 'Number(11)',
              desc: (
                <div>
                  마스터상품 고유번호
                  <ul className='style' style={{ color: 'gray' }}>
                    <li>
                      해당 번호가 같은 온라인상품은 동일 마스터상품에
                      묶여있습니다.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  온라인상품 등록시간
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
            },
            {
              title: 'mdate',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  온라인상품 수정시간
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String(4)',
              desc: '사이트 코드',
            },
            {
              title: 'shop_name',
              required: 'O',
              type: 'String(50)',
              desc: '사이트명',
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String(40)',
              desc: '사이트 아이디',
            },
            {
              title: 'std_ol_yn',
              required: 'O',
              type: 'Number(1)',
              desc: (
                <div>
                  단일상품여부
                  <div className='description'>(0: 일반상품, 1: 단일상품)</div>
                </div>
              ),
            },
            {
              title: 'ship_price_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  배송방법
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>무료</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>착불</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>선결제</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'ship_price',
              required: 'O',
              type: 'Number(8)',
              desc: '배송비',
            },
            {
              title: 'sale_status',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  상품 판매 상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>판매대기</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>승인대기</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>반려</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>판매중</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>종료대기</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>수정대기</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>판매중지</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>일시품절</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'sale_cnt_limit',
              required: 'O',
              type: 'Number(10)',
              desc: '쇼핑몰 판매수량',
            },
            {
              title: 'sale_price',
              required: 'O',
              type: 'Number(12)',
              desc: '판매가',
            },
            {
              title: 'supply_price',
              required: 'O',
              type: 'Number(12)',
              desc: '공급가',
            },
            {
              title: 'cost_price',
              required: 'O',
              type: 'Number(12)',
              desc: '원가',
            },
            {
              title: 'street_price',
              required: 'O',
              type: 'Number(12)',
              desc: '시중가',
            },
            {
              title: 'shop_sale_name',
              required: 'O',
              type: 'String(200)',
              desc: '쇼핑몰 상품명',
            },
            {
              title: 'shop_sale_no',
              required: 'O',
              type: 'String(40)',
              desc: (
                <div>
                  쇼핑몰 상품코드
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'detail_desc',
              required: 'O',
              type: 'String(16777215)',
              desc: '상품 상세설명',
            },
            {
              title: 'keywords',
              required: 'O',
              type: 'String[]',
              desc: '키워드',
            },
            {
              title: 'barcode',
              required: 'O',
              type: 'String(50)',
              desc: '바코드',
            },
            {
              title: 'isbn',
              required: 'O',
              type: 'Number(13)',
              desc: (
                <div>
                  isbn 번호
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'adult_yn',
              required: 'O',
              type: 'Number(1)',
              desc: (
                <div>
                  미성년자 구매가능여부
                  <div className='description'>
                    (0: 미성년자 구매가능, 1: 미성년자 구매불가)
                  </div>
                </div>
              ),
            },
            {
              title: 'model',
              required: 'O',
              type: 'String(50)',
              desc: '모델명',
            },
            {
              title: 'brand',
              required: 'O',
              type: 'String(50)',
              desc: '브랜드',
            },
            {
              title: 'maker',
              required: 'O',
              type: 'String(50)',
              desc: '제조사',
            },
            {
              title: 'made_date',
              required: 'O',
              type: 'String(10)',
              desc: (
                <div>
                  제조일
                  <div className='description'>(YYYY-MM-DD)</div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'expire_date',
              required: 'O',
              type: 'String(10)',
              desc: (
                <div>
                  유효일
                  <div className='description'> (YYYY-MM-DD)</div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'tax_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  과세여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>과세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>면세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>영세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>비과세</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'prod_condition',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  상품 상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>new</code>
                          </strong>
                        </td>
                        <td>신상품</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>used</code>
                          </strong>
                        </td>
                        <td>중고상품</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'ship_carr_no',
              required: 'O',
              type: 'Number(8)',
              desc: '배송 택배사코드',
            },
            {
              title: 'ship_leadtime',
              required: 'O',
              type: 'Number(8)',
              desc: '배송 소요일',
            },
            {
              title: 'bundle_ship_avail_yn',
              required: 'O',
              type: 'Boolean',
              desc: '묶음배송 가능 여부',
            },
            {
              title: 'min_sale_qty_yn',
              required: 'O',
              type: 'Boolean',
              desc: '최소 구매수량 사용 여부',
            },
            {
              title: 'min_sale_qty',
              required: '',
              type: 'Number(8)',
              desc: '최소 구매수량',
            },
            {
              title: 'max_sale_qty_yn',
              required: 'O',
              type: 'Boolean',
              desc: '최대 구매수량 사용 여부',
            },
            {
              title: 'max_sale_qty',
              required: '',
              type: 'Number(8)',
              desc: '최대 구매수량',
            },
            {
              title: 'max_sale_qty_creteria',
              required: '',
              type: 'String',
              desc: (
                <div>
                  최대 구매수량 타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>person</code>
                          </strong>
                        </td>
                        <td>구매자별 '수량 제한'</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>ord</code>
                          </strong>
                        </td>
                        <td>주문별 '1회 제한'</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'sale_img1',
              required: 'O',
              type: 'String(230)',
              desc: '기본이미지',
            },
            {
              title: 'sale_img2',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 1',
            },
            {
              title: 'sale_img3',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 2',
            },
            {
              title: 'sale_img4',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 3',
            },
            {
              title: 'sale_img5',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 4',
            },
            {
              title: 'sale_img6',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 5',
            },
            {
              title: 'sale_img7',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 6',
            },
            {
              title: 'sale_img8',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 7',
            },
            {
              title: 'sale_img9',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 8',
            },
            {
              title: 'sale_img10',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 9',
            },
            {
              title: 'sale_img11',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 10',
            },
            {
              title: 'sale_img12',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 11',
            },
            {
              title: 'sale_img13',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 12',
            },
            {
              title: 'sale_img14',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 13',
            },
            {
              title: 'sale_img15',
              required: 'O',
              type: 'String(230)',
              desc: '추가이미지 14',
            },
            {
              title: 'madein_no',
              required: 'O',
              type: 'Number',
              desc: '원산지번호',
            },
            {
              title: 'madein_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  원산지 국내/해외 여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>국내</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>해외</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>원양선</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>기타</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'madein_group',
              required: 'O',
              type: 'String(30)',
              desc: (
                <div>
                  원산지 시/도
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'madein_name',
              required: 'O',
              type: 'String(30)',
              desc: (
                <div>
                  원산지 읍/면
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'madein_etc',
              required: 'O',
              type: 'String(30)',
              desc: (
                <div>
                  기타원산지
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'multi_madein_yn',
              required: 'O',
              type: 'Number(1)',
              desc: (
                <div>
                  복수원산지여부
                  <div className='description'>
                    (0: 복수원산지X, 1: 복수원산지O)
                  </div>
                </div>
              ),
            },
            {
              title: 'template_no',
              required: 'O',
              type: 'Number(10)',
              desc: '쇼핑몰 템플릿 번호',
            },
            {
              title: 'template_name',
              required: 'O',
              type: 'String(80)',
              desc: '쇼핑몰 템플릿 명',
            },
            {
              title: 'shop_cate_info',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 카테고리 정보',
            },
            {
              title: 'input_opt_names',
              required: 'O',
              type: 'String[]',
              desc: '입력형옵션',
            },
            {
              title: 'opt_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  dhqtusrnqns
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>옵션없음</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>조합형</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>독립형</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'opts',
              required: 'O',
              type: 'object[]',
              desc: <div>옵션</div>,
            },
            {
              title: 'model_no',
              required: 'O',
              type: 'String(50)',
              desc: (
                <div>
                  Hmall 옵션 관리코드
                  <div className='description'>
                    (속성코드번호 + 옵션품목코드)
                  </div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'sale_opt_seq',
              required: 'O',
              type: 'Number(5)',
              desc: '옵션순번',
              indent: 1,
            },
            {
              title: 'deal_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  옵션타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>일반</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'opt_sort1',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 1',
              indent: 1,
            },
            {
              title: 'opt_sort2',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 2',
              indent: 1,
            },
            {
              title: 'opt_sort3',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 3',
              indent: 1,
            },
            {
              title: 'opt_sort1_desc',
              required: 'O',
              type: 'String(80)',
              desc: '옵션값1',
              indent: 1,
            },
            {
              title: 'opt_sort2_desc',
              required: 'O',
              type: 'String(80)',
              desc: (
                <div>
                  옵션값2
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'opt_sort3_desc',
              required: 'O',
              type: 'String(80)',
              desc: (
                <div>
                  옵션값3
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'add_price',
              required: 'O',
              type: 'Number(9)',
              desc: '옵션 추가금액',
              indent: 1,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Number(8)',
              desc: '옵션수량',
              indent: 1,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  옵션상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>정상</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>품절</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'prod_info',
              required: 'O',
              type: 'Object[]',
              desc: (
                <div>
                  상품정보제공고시
                  <br />
                  <ul className='style' style={{ color: 'gray' }}>
                    <li>
                      상품분류코드에 따라 infoDetail 안에 키 값이 달라질 수
                      있습니다.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'infoCode',
              required: 'O',
              type: 'String',
              desc: '상품분류코드',
              indent: 1,
            },
            {
              title: 'infoName',
              required: 'O',
              type: 'String',
              desc: '상품분류명',
              indent: 1,
            },
            {
              title: 'infoDetail',
              required: 'O',
              type: 'Object',
              desc: '상품정보제공고시 데이터',
              indent: 1,
            },
            {
              title: 'cert_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  인증정보타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>인증유형등록</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>인증대상아님</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>상세설명내등록</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'certs',
              required: 'O',
              type: 'object[]',
              desc: '인증정보',
            },
            {
              title: 'ol_shop_cert_seq',
              required: 'O',
              type: 'object[]',
              desc: '인증번호 순번',
              indent: 1,
            },
            {
              title: 'cert_cd',
              required: 'O',
              type: 'String(7)',
              desc: (
                <div>
                  인증유형
                  <br />
                  <ul className='style' style={{ color: 'gray' }}>
                    {' '}
                    <li>cert_01: 생활용품 안전인증</li>{' '}
                    <li>cert_02: 생활용품 안전확인</li>{' '}
                    <li>cert_03: 생활용품 어린이보호포장</li>{' '}
                    <li>cert_04: 생활용품 안전품질표시</li>{' '}
                    <li>cert_05: 생활용품 공급자적합성확인</li>{' '}
                    <li>cert_06: 전기용품 안전인증</li>{' '}
                    <li>cert_07: 전기용품 안전확인</li>{' '}
                    <li>cert_08: 전기용품 공급자적합성확인</li>{' '}
                    <li>cert_09: 방송통신용품 적합성인증확인</li>{' '}
                    <li>cert_10: 어린이제품 안전인증</li>{' '}
                    <li>cert_11: 어린이제품 안전확인</li>{' '}
                    <li>cert_12: 어린이제품 공급자적합성확인</li>{' '}
                    <li>cert_13: 위해우려제품 자가검사</li>{' '}
                    <li>cert_14: 방송통신기자재 잠정인증</li>{' '}
                    <li>cert_15: 방송통신기자재 적합등록</li>{' '}
                    <li>cert_16: 원산지증명</li> <li>cert_17: 해외안전인증</li>{' '}
                    <li>cert_18: 수입신고필증</li>{' '}
                    <li>cert_19: 친환경인증-무농약농산물</li>{' '}
                    <li>cert_20: 친환경인증-유기축산물</li>{' '}
                    <li>cert_21: 친환경인증-유기농산물</li>{' '}
                    <li>cert_22: 친환경인증-저농약농산물</li>{' '}
                    <li>cert_23: 친환경인증-무항생제축산물</li>{' '}
                    <li>cert_24: HACCP(위해요소 중점관리우수식품)</li>{' '}
                    <li>cert_25: GMP(우수건강기능식품 제조기준)</li>{' '}
                    <li>cert_26: GAP(농산물우수관리인증)</li>{' '}
                    <li>cert_27: 농산물이력추적관리</li>{' '}
                    <li>cert_28: 수산물품질인증</li>{' '}
                    <li>cert_29: 수산특산물품질인증</li>{' '}
                    <li>cert_30: 수산전통식품품질인증</li>{' '}
                    <li>cert_31: 친환경수산물품질인증</li>{' '}
                    <li>cert_32: 친환경수산가공품품질인증</li>{' '}
                    <li>cert_33: 전통식품 품질인증</li>{' '}
                    <li>cert_34: 유기가공식품 인증</li>{' '}
                    <li>cert_35: 가공식품 산업표준 KS인증</li>{' '}
                    <li>cert_36: 건강기능식품 광고사전심의</li>{' '}
                    <li>cert_37: 의료기기 광고사전심의</li>{' '}
                    <li>cert_38: 축산물 등급판정 확인서</li>{' '}
                    <li>cert_39: 도축검사증명서</li>{' '}
                    <li>cert_40: 식품명인(Grand master) 인증</li>{' '}
                    <li>cert_41: 사회적기업 인증</li>{' '}
                    <li>cert_42: 6차산업 인증</li>{' '}
                    <li>cert_43: 동물복지 인증</li>{' '}
                    <li>cert_44: 마을기업 인증</li>{' '}
                    <li>cert_45: 건강기능식품인증</li>{' '}
                    <li>cert_46: 생활화학제품</li>{' '}
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'cert_exc_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  면제유형
                  <br />
                  <ul className='style' style={{ color: 'gray' }}>
                    <li>kc_01: 안전기준준수대상</li>
                    <li>kc_02: 구매대행</li>
                    <li>kc_03: 병행수입</li>
                  </ul>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>kc_01</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>kc_02</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>kc_03</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'cert_ministry',
              required: 'O',
              type: 'String',
              desc: '인증기관',
              indent: 1,
            },
            {
              title: 'cert_no',
              required: 'O',
              type: 'String',
              desc: '인증번호',
              indent: 1,
            },
            {
              title: 'cert_model',
              required: 'O',
              type: 'String',
              desc: '인증모델',
              indent: 1,
            },
            {
              title: 'cert_cname',
              required: 'O',
              type: 'String',
              desc: '인증상호',
              indent: 1,
            },
            {
              title: 'cert_date',
              required: 'O',
              type: 'String',
              desc: '인증일',
              indent: 1,
            },
            {
              title: 'cert_expire_date',
              required: 'O',
              type: 'String',
              desc: '인증만료일',
              indent: 1,
            },
          ],
          response_example: {
            sol_no: 640,
            ol_shop_no: 69224645,
            c_sale_cd: 'm2022060881c9e7f86',
            sale_no: 11142002,
            wdate: '2026-01-21 12:34:17',
            mdate: '2026-01-21 12:34:17',
            shop_cd: 'B616',
            shop_name: '카페24(신)',
            shop_id: 'testcafe24',
            std_ol_yn: 0,
            ship_price_type: '무료',
            ship_price: 0,
            sale_status: '판매중',
            sale_cnt_limit: 99,
            sale_price: 10000,
            supply_price: 9000,
            cost_price: 8000,
            street_price: 11000,
            shop_sale_name: '테스트 온라인 상품',
            shop_sale_no: '123123',
            detail_desc: '상세설명',
            keywords: [],
            barcode: '',
            isbn: 7777777777777,
            adult_yn: 0,
            model: '모델명',
            brand: '브랜드',
            maker: '제조사',
            made_date: '2026-01-01',
            expire_date: '2026-01-22',
            tax_type: '과세',
            prod_condition: 'new',
            ship_carr_no: 4,
            ship_leadtime: 2,
            bundle_ship_avail_yn: true,
            min_sale_qty_yn: false,
            max_sale_qty_yn: true,
            max_sale_qty: 1,
            max_sale_qty_creteria: 'person',
            sale_img1:
              'https://s3-ap-northeast-2.amazonaws.com/gmp01/640/online/26070990/Z000/202111041549441.jpg',
            sale_img2: '',
            sale_img3: '',
            sale_img4: '',
            sale_img5: '',
            sale_img6: '',
            sale_img7: '',
            sale_img8: '',
            sale_img9: '',
            sale_img10: '',
            sale_img11: '',
            sale_img12: '',
            sale_img13: '',
            sale_img14: '',
            sale_img15: '',
            madein_no: 20,
            madein_type: '국내',
            madein_group: '경기',
            madein_name: '고양시',
            madein_etc: null,
            multi_madein_yn: 0,
            template_no: 2252130,
            template_name: '카페24 템플릿1',
            shop_cate_info: '(대분류) Outerwear > (중분류) Jackets',
            input_opt_names: ['입력형옵션1', '입력형옵션2'],
            opt_type: '조합형',
            opts: [
              {
                model_no: '00001-00001',
                sale_opt_seq: 1,
                deal_type: '일반',
                opt_sort1: '색상',
                opt_sort2: '사이즈',
                opt_sort3: '',
                opt_sort1_desc: '블랙',
                opt_sort2_desc: 'L',
                opt_sort3_desc: '',
                add_price: 0,
                stock_cnt: 77,
                status: '정상',
              },
              {
                model_no: '00002-00001',
                sale_opt_seq: 2,
                deal_type: '일반',
                opt_sort1: '색상',
                opt_sort2: '사이즈',
                opt_sort3: '',
                opt_name1: '하늘',
                opt_name2: 'L',
                opt_name3: '',
                add_price: 0,
                stock_cnt: 66,
                status: '정상',
              },
              {
                model_no: '00001-00002',
                sale_opt_seq: 1,
                deal_type: '일반',
                opt_sort1: '색상',
                opt_sort2: '사이즈',
                opt_sort3: '',
                opt_name1: '블랙',
                opt_name2: 'S',
                opt_name3: '',
                add_price: 0,
                stock_cnt: 77,
                status: '정상',
              },
              {
                model_no: '00002-00002',
                sale_opt_seq: 2,
                deal_type: '일반',
                opt_sort1: '색상',
                opt_sort2: '사이즈',
                opt_sort3: '',
                opt_name1: '하늘',
                opt_name2: 'S',
                opt_name3: '',
                add_price: 0,
                stock_cnt: 66,
                status: '정상',
              },
            ],
            prod_info: [
              {
                infoCode: 'Wear2023',
                infoName: '의류',
                infoDetail: {
                  material: '1',
                  color: '2',
                  size: '3',
                  manufacturer: '4',
                  made_in: '5',
                  caution: '6',
                  release: '7',
                  warranty: '8',
                  customer_service: '9',
                },
              },
            ],
            cert_type: '인증유형등록',
            certs: [
              {
                ol_shop_cert_seq: 1,
                cert_cd: 'cert_01',
                cert_exc_type: 'kc_01',
                cert_ministry: '인증기관',
                cert_no: '인증번호',
                cert_model: '인증모델',
                cert_cname: '인증상호',
                cert_date: '2025-03-01',
                cert_expire_date: '2026-12-31',
              },
            ],
          },
        },
      ],
    },
    {
      title: '온라인상품 등록',
      url: '/doc/Hmall/온라인상품 등록',
      data: [
        {
          version: 'hmall',
          url: '/product/add/hmall',
          desc: (
            <div>
              <ul className='style'>
                <li>2.0 솔루션에 온라인상품 정보를 등록합니다.</li>
                <li>
                  <div style={{ color: 'red' }}>
                    쇼핑몰에 등록되는 것은 아닙니다. 쇼핑몰 등록은 작업 API 를
                    사용해주세요.
                  </div>
                </li>
                <li>
                  단일상품의 경우 쇼핑몰별로 입력가능한 옵션이 다를 수 있습니다.
                </li>
              </ul>
            </div>
          ),
          method: 'POST',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  판매자관리코드
                  <br />
                  <ul className='style no-margin' style={{ color: 'gray' }}>
                    <li>
                      <strong>
                        <code>__AUTO__</code>
                      </strong>
                      로 입력시 판매자관리코드를 자동생성합니다.
                    </li>
                    <li>
                      원할한 상품관리를 위해 Hmall 에서 관리하는 Product 단위의
                      고유코드로 입력하기를 권장합니다.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'playauto_cate_no',
              required: 'O',
              type: 'Number',
              desc: (
                <div>
                  플레이오토 표준 카테고리 번호
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>
                      플레이오토 표준 카테고리 번호를{' '}
                      <a
                        href='https://cloud.plto.com/sampleExcel/Sample_standard_category/Standard_category_list.xlsx'
                        target='_blank'
                        rel='noreferrer'
                        style={{ color: 'blue' }}
                      >
                        엑셀
                      </a>{' '}
                      에서 확인 후 입력해주십시오.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'shop_sale_name',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  상품명
                  <br />
                  <ul className='style no-margin' style={{ color: 'gray' }}>
                    <li>상품명은 최대 100Byte까지 등록가능합니다.</li>
                    <li>
                      특수문자는 - _ / ~ + . , ( ) {} [ ] % & ' :만 사용
                      가능합니다.{' '}
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'sale_price',
              required: 'O',
              type: 'Number',
              desc: (
                <div>
                  판매가격
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>금액은 10원 단위로 입력해주십시오.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'sale_cnt_limit',
              required: 'O',
              type: 'Number',
              desc: '판매수량',
            },
            {
              title: 'site_list',
              required: 'O',
              type: 'Object[]',
              desc: '등록할 쇼핑몰 정보',
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  쇼핑몰코드
                  <ul style={{ color: 'gray' }}>
                    <li>
                      토스 쇼핑: A538, 베네피아: B513, 카페24(신): B616,
                      지그재그-포스티: P018
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 아이디',
              indent: 1,
            },
            {
              title: 'shop_sale_name',
              required: '',
              type: 'String',
              desc: (
                <div>
                  상품명 개별입력
                  <ul className='style no-margin' style={{ color: 'gray' }}>
                    <li>상품명 글자 제한수는 쇼핑몰별로 상이합니다.</li>
                    <li>
                      특수문자는 - _ / ~ + . , ( ) [ ] % & ' :만 사용
                      가능합니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'shop_cate_info',
              required: '',
              type: 'Object',
              desc: (
                <div>
                  개별 카테고리 정보
                  <ul style={{ color: 'gray' }}>
                    <li>카페24(신) 카테고리 등록시에만 사용 가능합니다.</li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'code',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  카테고리 코드
                  <ul style={{ color: 'gray' }}>
                    <li>
                      'lcate01_mcate02_scate01_dcate04' 와 같이 대분류부터 전체
                      코드를 '_' 기호로 합쳐서 넣어주세요.
                    </li>
                  </ul>
                </div>
              ),
              indent: 2,
            },
            {
              title: 'name',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  카테고리 명
                  <ul style={{ color: 'gray' }}>
                    <li>
                      '패션{'>'}여성의류{'>'}하의{'>'}치마' 와 같이 대분류부터
                      전체 코드를 '{'>'}' 기호로 합쳐서 넣어주세요.
                    </li>
                  </ul>
                </div>
              ),
              indent: 2,
            },
            {
              title: 'template_no',
              required: 'O',
              type: 'Number',
              desc: (
                <div>
                  템플릿 번호
                  <ul style={{ color: 'gray' }}>
                    <li>
                      <a
                        href='/doc/Hmall/템플릿 등록/수정'
                        style={{ color: 'blue' }}
                      >
                        템플릿 등록/수정{' '}
                      </a>
                      &nbsp;API 로 등록하신 템플릿 번호를 작성해주세요.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            // 일단 단일상품은 제외
            // {
            //   title: 'model_no',
            //   required: '',
            //   type: 'String',
            //   desc: (
            //     <div>
            //       단일상품의 Hmall 옵션 관리코드
            //       <div className='description'>
            //         (속성코드번호 + 옵션품목코드)
            //       </div>
            //     </div>
            //   ),
            // },
            {
              title: 'input_opt_names',
              required: '',
              type: 'String[]',
              desc: '입력형옵션',
            },
            {
              title: 'opt_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  옵션구분
                  <ul style={{ color: 'gray' }}>
                    <li>
                      옵션명은 하나이지만 옵션값이 여러개일 경우도 조합형
                      옵션입니다.
                    </li>
                  </ul>
                  <div>
                    <div className='description' style={{ padding: '12px 0' }}>
                      Allowed values
                    </div>
                    <table>
                      <thead>
                        <tr>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong>
                              <code>옵션없음</code>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>조합형</code>
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ),
            },
            {
              title: 'opts',
              required: '',
              type: 'Object[]',
              desc: (
                <div>
                  옵션
                  <ul style={{ color: 'gray' }}>
                    <li>옵션구분이 옵션없음이 아닌경우 필수입력</li>
                  </ul>
                  <pre>
                    <span className='pun'>{'//'}</span>
                    <span className='pun'>
                      &nbsp;옵션정보가 [색상 = 빨강,파랑] 인 경우
                    </span>
                    <br />
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort1"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"색상"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort1_desc"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"빨강"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>...</span>
                    <br />
                    <span className='pun'>{'},'}</span>
                    <br />
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort1"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"색상"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort1_desc"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"파랑"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>...</span>
                    <br />
                    <span className='pun'>{'}'}</span>
                    <br />
                    <br />
                    <span className='pun'>{'//'}</span>
                    <span className='pun'>
                      &nbsp;옵션정보가 [색상 = 빨강,파랑, 사이즈 = Large,Small]
                      인 경우
                    </span>
                    <br />
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort1"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"색상"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort2"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"사이즈"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort1_desc"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"빨강"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort2_desc"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"Large"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>...</span>
                    <br />
                    <span className='pun'>{'},'}</span>
                    <br />
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort1"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"색상"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort2"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"사이즈"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort1_desc"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"빨강"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort2_desc"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"Small"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>...</span>
                    <br />
                    <span className='pun'>{'},'}</span>
                    <br />
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort1"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"색상"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort2"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"사이즈"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort1_desc"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"파랑"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort2_desc"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"Large"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>...</span>
                    <br />
                    <span className='pun'>{'},'}</span>
                    <br />
                    <span className='pun'>{'{'}</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort1"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"색상"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort2"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"사이즈"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort1_desc"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"파랑"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>"opt_sort2_desc"</span>
                    <span className='pun'>:&nbsp;</span>
                    <span className='str'>"Small"</span>
                    <span className='pun'>,</span>
                    <br />
                    <span className='pln'>&nbsp;&nbsp;</span>
                    <span className='str'>...</span>
                    <br />
                    <span className='pun'>{'}'}</span>
                    <br />
                  </pre>
                </div>
              ),
            },
            {
              title: 'model_no',
              required: 'O',
              type: 'String(50)',
              desc: (
                <div>
                  Hmall 옵션 관리코드
                  <div className='description'>
                    (속성코드번호 + 옵션품목코드)
                  </div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'opt_sort1',
              required: 'O',
              type: 'String',
              desc: '옵션명1',
              indent: 1,
            },
            {
              title: 'opt_sort2',
              required: '',
              type: 'String',
              desc: '옵션명2',
              indent: 1,
            },
            {
              title: 'opt_sort3',
              required: '',
              type: 'String',
              desc: '옵션명3',
              indent: 1,
            },
            {
              title: 'opt_sort1_desc',
              required: 'O',
              type: 'String',
              desc: '옵션값1',
              indent: 1,
            },
            {
              title: 'opt_sort2_desc',
              required: '',
              type: 'String',
              desc: '옵션값2',
              indent: 1,
            },
            {
              title: 'opt_sort3_desc',
              required: '',
              type: 'String',
              desc: '옵션값3',
              indent: 1,
            },
            {
              title: 'add_price',
              required: '',
              type: 'Number',
              desc: '추가옵션금액',
              indent: 1,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Number',
              desc: '판매수량',
              indent: 1,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  옵션상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>정상</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>품절</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'madein',
              required: 'O',
              type: 'Object',
              desc: '원산지',
            },
            {
              title: 'madein_no',
              required: 'O',
              type: 'Number',
              desc: (
                <div>
                  원산지번호
                  <ul style={{ color: 'gray' }}>
                    <li>
                      <a href='/doc/원산지 조회' style={{ color: 'blue' }}>
                        원산지 조회{' '}
                      </a>
                      &nbsp;API 를 참고하여 작성해주세요.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'madein_etc',
              required: '',
              type: 'String',
              desc: (
                <div>
                  기타원산지
                  <ul style={{ color: 'gray' }}>
                    <li>
                      등록하려는 원산지가 origins 에서 조회되지 않을 때
                      madein_no 를 비우고 madein_etc 에 값을 입력합니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'tax_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  과세여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>과세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>면세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>영세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>비과세</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'ship_price_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  배송방법
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>무료</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>선결제</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>착불</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'ship_price',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  배송비
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>배송방법이 무료가 아닌경우 필수 입니다.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'ship_carr_no',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  배송 택배사코드
                  <ul style={{ color: 'gray' }}>
                    <li>
                      <a href='/doc/택배사 코드 조회' style={{ color: 'blue' }}>
                        택배사 코드 조회{' '}
                      </a>
                      &nbsp;API 로 확인한 택배사 코드를 작성해주세요.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'ship_leadtime',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '배송 소요일',
                sub: '1 ~ 14 사이의 값을 입력합니다.',
              }),
            },
            {
              title: 'prod_condition',
              required: '',
              type: 'String',
              desc: (
                <div>
                  상품 상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>new</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>new</code>
                          </strong>
                        </td>
                        <td>신상품</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>used</code>
                          </strong>
                        </td>
                        <td>중고상품</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'bundle_ship_avail_yn',
              required: '',
              type: 'Boolean',
              desc: (
                <div>
                  묶음배송 가능 여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>true</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'min_sale_qty_yn',
              required: '',
              type: 'Boolean',
              desc: (
                <div>
                  최소 구매수량 사용 여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>false</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'min_sale_qty',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  최소 구매수량
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>최소 구매수량 사용시 필수 입니다.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'max_sale_qty_yn',
              required: '',
              type: 'Boolean',
              desc: (
                <div>
                  최대 구매수량 사용 여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>false</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'max_sale_qty',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  최대 구매수량
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>최대 구매수량 사용시 필수 입니다.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'max_sale_qty_creteria',
              required: '',
              type: 'String',
              desc: (
                <div>
                  최대 구매수량 타입
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>최대 구매수량 사용시 필수 입니다.</li>
                  </ul>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>person</code>
                          </strong>
                        </td>
                        <td>구매자별 '수량 제한'</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>ord</code>
                          </strong>
                        </td>
                        <td>주문별 '1회 제한'</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'detail_desc',
              required: 'O',
              type: 'String',
              desc: '상품상세설명',
            },
            {
              title: 'sale_img1',
              required: 'O',
              type: 'String',
              desc: '기본이미지 URL',
            },
            {
              title: 'sale_img2',
              required: '',
              type: 'String',
              desc: '추가이미지 1 URL',
            },
            {
              title: 'sale_img3',
              required: '',
              type: 'String',
              desc: '추가이미지 2 URL',
            },
            {
              title: 'sale_img4',
              required: '',
              type: 'String',
              desc: '추가이미지 3 URL',
            },
            {
              title: 'sale_img5',
              required: '',
              type: 'String',
              desc: '추가이미지 4 URL',
            },
            {
              title: 'sale_img6',
              required: '',
              type: 'String',
              desc: '추가이미지 5 URL',
            },
            {
              title: 'sale_img7',
              required: '',
              type: 'String',
              desc: '추가이미지 6 URL',
            },
            {
              title: 'sale_img8',
              required: '',
              type: 'String',
              desc: '추가이미지 7 URL',
            },
            {
              title: 'sale_img9',
              required: '',
              type: 'String',
              desc: '추가이미지 8 URL',
            },
            {
              title: 'sale_img10',
              required: '',
              type: 'String',
              desc: '추가이미지 9 URL',
            },
            {
              title: 'sale_img11',
              required: '',
              type: 'String',
              desc: '추가이미지 10 URL',
            },
            {
              title: 'prod_info',
              required: 'O',
              type: 'Object[]',
              desc: (
                <div>
                  상품정보제공고시
                  <br />
                  <ul className='style no-margin' style={{ color: 'gray' }}>
                    <li>품목정보고시정보는 3개까지 입력가능합니다.</li>
                    <li>아래의 등록가이드를 참고해주세요.</li>
                    <li>
                      <a
                        href='https://gmp-master.s3.ap-northeast-2.amazonaws.com/download/Sample_prodInfo_guide_OPENAPI.xlsx'
                        style={{ color: 'blue' }}
                      >
                        상품 품목정보고시 가이드 개정판
                      </a>
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'infoCode',
              required: 'O',
              type: 'String',
              desc: '상품분류코드',
              indent: 1,
            },
            {
              title: 'infoDetail',
              required: 'O',
              type: 'object',
              desc: (
                <div>
                  상품 정보 제공고시 데이터
                  <ul style={{ color: 'gray' }}>
                    <li>
                      품목 정보고시 가이드에 기재된 각 항목에 따른 key와 value를
                      입력합니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'is_desc_referred',
              type: 'boolean',
              desc: (
                <div>
                  상품 정보 제공고시 데이터 일괄 [상세설명참조] 적용
                  <ul style={{ color: 'gray' }}>
                    <li>
                      해당 값을 <code>true</code> 로 설정 시 입력한 값과 상관
                      없이 일괄 <code>[상세설명참조]</code>로 적용됩니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'brand',
              required: '',
              type: 'String',
              desc: '브랜드',
            },
            {
              title: 'model',
              required: '',
              type: 'String',
              desc: '모델명',
            },
            {
              title: 'maker',
              required: '',
              type: 'String',
              desc: '제조사',
            },
            {
              title: 'adult_yn',
              required: '',
              type: 'Boolean',
              desc: (
                <div>
                  미성년자 구매여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>true</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'made_date',
              required: '',
              type: 'String',
              desc: (
                <div>
                  제조일자
                  <ul style={{ color: 'gray' }}>
                    <li>YYYY-MM-DD의 날짜형식으로 입력해주십시오.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'expire_date',
              required: '',
              type: 'String',
              desc: (
                <div>
                  유효일자
                  <ul style={{ color: 'gray' }}>
                    <li>YYYY-MM-DD의 날짜형식으로 입력해주십시오.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'keywords',
              required: '',
              type: 'String[]',
              desc: (
                <div>
                  키워드
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>
                      키워드는 최대 40개 까지 등록가능하며, 쇼핑몰에 상품전송시
                      쇼핑몰에서 지원하는 입력 갯수만큼만 전송됩니다.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'supply_price',
              required: '',
              type: 'Number',
              desc: '공급가',
            },
            {
              title: 'cost_price',
              required: '',
              type: 'Number',
              desc: '원가',
            },
            {
              title: 'street_price',
              required: '',
              type: 'Number',
              desc: '시중가',
            },
            {
              title: 'gift_name',
              required: '',
              type: 'String',
              desc: '사은품',
            },
            {
              title: 'isbn',
              required: '',
              type: 'Number',
              desc: 'ISBN 코드',
            },
            {
              title: 'barcode',
              required: '',
              type: 'String',
              desc: '바코드',
            },
            {
              title: 'hscd',
              required: '',
              type: 'String',
              desc: 'HS코드',
            },
            {
              title: 'global_barcode_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  UPC/EAN 타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>UPC</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>EAN</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'global_barcode',
              required: '',
              type: 'Number',
              desc: 'UPC/EAN 코드',
            },
            {
              title: 'prod_weight',
              required: '',
              type: 'Number',
              desc: '상품무게',
            },
            {
              title: 'cert_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  인증정보타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>인증대상아님</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>인증유형등록</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>인증대상아님</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>상세설명내등록</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'certs',
              required: '',
              type: 'Object[]',
              desc: (
                <div>
                  인증정보
                  <br />
                  <ul className='style no-margin' style={{ color: 'gray' }}>
                    <li>인증정보는 10개까지 등록 가능합니다.</li>
                    <li>
                      인증정보타입이 인증유형등록인 경우 필수로 입력해주셔야
                      합니다.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'cert_cd',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  인증유형
                  <br />
                  <ul className='style no-margin' style={{ color: 'gray' }}>
                    <li>cert_01: 생활용품 안전인증</li>
                    <li>cert_02: 생활용품 안전확인</li>
                    <li>cert_03: 생활용품 어린이보호포장</li>
                    <li>cert_04: 생활용품 안전품질표시</li>
                    <li>cert_05: 생활용품 공급자적합성확인</li>
                    <li>cert_06: 전기용품 안전인증</li>
                    <li>cert_07: 전기용품 안전확인</li>
                    <li>cert_08: 전기용품 공급자적합성확인</li>
                    <li>cert_09: 방송통신용품 적합성인증확인</li>
                    <li>cert_10: 어린이제품 안전인증</li>
                    <li>cert_11: 어린이제품 안전확인</li>
                    <li>cert_12: 어린이제품 공급자적합성확인</li>
                    <li>cert_13: 위해우려제품 자가검사</li>
                    <li>cert_14: 방송통신기자재 잠정인증</li>
                    <li>cert_15: 방송통신기자재 적합등록</li>
                    <li>cert_16: 원산지증명</li> <li>cert_17: 해외안전인증</li>
                    <li>cert_18: 수입신고필증</li>
                    <li>cert_19: 친환경인증-무농약농산물</li>
                    <li>cert_20: 친환경인증-유기축산물</li>
                    <li>cert_21: 친환경인증-유기농산물</li>
                    <li>cert_22: 친환경인증-저농약농산물</li>
                    <li>cert_23: 친환경인증-무항생제축산물</li>
                    <li>cert_24: HACCP(위해요소 중점관리우수식품)</li>
                    <li>cert_25: GMP(우수건강기능식품 제조기준)</li>
                    <li>cert_26: GAP(농산물우수관리인증)</li>
                    <li>cert_27: 농산물이력추적관리</li>
                    <li>cert_28: 수산물품질인증</li>
                    <li>cert_29: 수산특산물품질인증</li>
                    <li>cert_30: 수산전통식품품질인증</li>
                    <li>cert_31: 친환경수산물품질인증</li>
                    <li>cert_32: 친환경수산가공품품질인증</li>
                    <li>cert_33: 전통식품 품질인증</li>
                    <li>cert_34: 유기가공식품 인증</li>
                    <li>cert_35: 가공식품 산업표준 KS인증</li>
                    <li>cert_36: 건강기능식품 광고사전심의</li>
                    <li>cert_37: 의료기기 광고사전심의</li>
                    <li>cert_38: 축산물 등급판정 확인서</li>
                    <li>cert_39: 도축검사증명서</li>
                    <li>cert_40: 식품명인(Grand master) 인증</li>
                    <li>cert_41: 사회적기업 인증</li>
                    <li>cert_42: 6차산업 인증</li>
                    <li>cert_43: 동물복지 인증</li>
                    <li>cert_44: 마을기업 인증</li>
                    <li>cert_45: 건강기능식품인증</li>
                    <li>cert_46: 생활화학제품</li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'cert_exc_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  면제유형
                  <br />
                  <ul className='style' style={{ color: 'gray' }}>
                    <li>kc_01: 안전기준준수대상</li>
                    <li>kc_02: 구매대행</li>
                    <li>kc_03: 병행수입</li>
                  </ul>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>kc_01</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>kc_02</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>kc_03</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'cert_ministry',
              required: '',
              type: 'String',
              desc: '인증기관',
              indent: 1,
            },
            {
              title: 'cert_no',
              required: 'O',
              type: 'String',
              desc: '인증번호',
              indent: 1,
            },
            {
              title: 'cert_model',
              required: '',
              type: 'String',
              desc: '인증모델',
              indent: 1,
            },
            {
              title: 'cert_cname',
              required: '',
              type: 'String',
              desc: '인증상호',
              indent: 1,
            },
            {
              title: 'cert_date',
              required: '',
              type: 'String',
              desc: (
                <div>
                  인증일
                  <ul style={{ color: 'gray' }}>
                    <li>YYYY-MM-DD의 날짜형식으로 입력해주십시오.</li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'cert_expire_date',
              required: '',
              type: 'String',
              desc: (
                <div>
                  인증만료일
                  <ul style={{ color: 'gray' }}>
                    <li>YYYY-MM-DD의 날짜형식으로 입력해주십시오.</li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
          ],
          body_example: {
            c_sale_cd: 'playauto_20260128_001',
            playauto_cate_no: 10031300,
            shop_sale_name: 'api 테스트 상품',
            sale_price: 50000,
            sale_cnt_limit: 999,
            site_list: [
              {
                shop_cd: 'A538',
                shop_id: 'playauto',
                template_no: 2252130,
              },
            ],
            opt_type: '조합형',
            opts: [
              {
                model_no: '00001-00001',
                opt_sort1: '색상',
                opt_sort2: '',
                opt_sort3: '',
                opt_sort1_desc: '빨강',
                opt_sort2_desc: '',
                opt_sort3_desc: '',
                add_price: 0,
                stock_cnt: 999,
                status: '정상',
              },
              {
                model_no: '00001-00002',
                opt_sort1: '색상',
                opt_sort2: '',
                opt_sort3: '',
                opt_sort1_desc: '파랑',
                opt_sort2_desc: '',
                opt_sort3_desc: '',
                add_price: 5000,
                stock_cnt: 999,
                status: '품절',
              },
            ],
            tax_type: '과세',
            madein: {
              madein_no: 2,
              madein_etc: '',
            },
            made_date: '2025-12-01',
            expire_date: '2026-12-31',
            max_sale_qty_yn: true,
            max_sale_qty: 1,
            max_sale_qty_creteria: 'person',
            detail_desc: '상세설명',
            brand: '브랜드',
            model: '모델명',
            maker: '제조사',
            sale_img1: 'https://sample.com/productImage.jpg',
            prod_info: [
              {
                infoCode: 'Wear2023',
                infoDetail: {},
                is_desc_referred: true,
              },
            ],
          },
          response: [
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: '성공/실패',
            },
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String',
              desc: '등록된 상품의 판매자관리코드',
            },
            {
              title: 'site_list',
              required: 'O',
              type: 'Object[]',
              desc: '등록된 상품 쇼핑몰 정보',
            },
            {
              title: 'shop_name',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 이름',
              indent: 1,
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 코드',
              indent: 1,
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 아이디 (마스터 상품의 경우 빈값 출력)',
              indent: 1,
            },
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'Number',
              desc: '등록된 온라인상품 고유번호',
              indent: 1,
            },
            {
              title: 'error_code',
              required: 'O',
              type: 'String',
              desc: '등록이 실패된 경우 에러코드',
            },
            {
              title: 'messages',
              required: 'O',
              type: 'String[]',
              desc: '등록이 실패된 경우 에러메시지',
            },
          ],
          response_example: {
            result: '성공',
            c_sale_cd: 'playauto_20260128_001',
            site_list: [
              {
                shop_name: '마스터 상품',
                shop_cd: 'Z000',
                shop_id: '',
                ol_shop_no: 374200040,
              },
              {
                shop_name: '토스 쇼핑',
                shop_cd: 'A538',
                shop_id: 'playauto',
                ol_shop_no: 374200041,
              },
            ],
            message: '',
          },
        },
      ],
    },
    {
      title: '온라인상품 수정',
      url: '/doc/Hmall/온라인상품 수정',
      data: [
        {
          version: 'hmall',
          url: '/product/edit/hmall',
          desc: (
            <div>
              <ul className='style'>
                <li>2.0 솔루션의 온라인상품 정보를 수정합니다.</li>
                <li>
                  <div style={{ color: 'red' }}>
                    쇼핑몰에 반영되는 것은 아닙니다. 쇼핑몰 반영은 작업 API 를
                    사용해주세요.
                  </div>
                </li>
              </ul>
            </div>
          ),
          method: 'PUT',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'Number(10)',
              desc: (
                <div>
                  온라인상품 고유번호
                  <br />
                  <ul className='style no-margin' style={{ color: 'gray' }}>
                    <li>
                      온라인상품 고유번호를 제외한 모든 항목은 비필수 입니다.
                    </li>
                    <li>
                      수정이 필요한 경우에 입력해주십시오. 미입력시 기존값은
                      유지됩니다.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'playauto_cate_no',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  플레이오토 표준 카테고리 번호
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>
                      플레이오토 표준 카테고리 번호를{' '}
                      <a
                        href='https://cloud.plto.com/sampleExcel/Sample_standard_category/Standard_category_list.xlsx'
                        target='_blank'
                        rel='noreferrer'
                        style={{ color: 'blue' }}
                      >
                        엑셀
                      </a>{' '}
                      에서 확인 후 입력해주십시오.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'shop_cate_info',
              required: '',
              type: 'Object',
              desc: (
                <div>
                  개별 카테고리 정보
                  <ul style={{ color: 'gray' }}>
                    <li>카페24(신) 카테고리 수정시에만 사용 가능합니다.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'code',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  카테고리 코드
                  <ul style={{ color: 'gray' }}>
                    <li>
                      'lcate01_mcate02_scate01_dcate04' 와 같이 대분류부터 전체
                      코드를 '_' 기호로 합쳐서 넣어주세요.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'name',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  카테고리 명
                  <ul style={{ color: 'gray' }}>
                    <li>
                      '패션{'>'}여성의류{'>'}하의{'>'}치마' 와 같이 대분류부터
                      전체 코드를 '{'>'}' 기호로 합쳐서 넣어주세요.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'shop_sale_name',
              required: '',
              type: 'String',
              desc: (
                <div>
                  상품명 개별입력
                  <ul className='style no-margin' style={{ color: 'gray' }}>
                    <li>상품명 글자 제한수는 쇼핑몰별로 상이합니다.</li>
                    <li>
                      특수문자는 - _ / ~ + . , ( ) [ ] % & ' :만 사용
                      가능합니다.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'sale_price',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  판매가격
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>금액은 10원 단위로 입력해주십시오.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'sale_cnt_limit',
              required: '',
              type: 'Number',
              desc: '판매수량',
            },
            {
              title: 'template_no',
              required: '',
              type: 'Numnber',
              desc: (
                <div>
                  템플릿 번호
                  <ul style={{ color: 'gray' }}>
                    <li>
                      <a
                        href='/doc/Hmall/템플릿 등록/수정'
                        style={{ color: 'blue' }}
                      >
                        템플릿 등록/수정{' '}
                      </a>
                      &nbsp;API 로 등록하신 템플릿 번호를 작성해주세요.
                    </li>
                  </ul>
                </div>
              ),
            },
            // 일단 단일상품은 제외
            // {
            //   title: 'model_no',
            //   required: '',
            //   type: 'String',
            //   desc: (
            //     <div>
            //       단일상품의 Hmall 옵션 관리코드
            //       <div className='description'>
            //         (속성코드번호 + 옵션품목코드)
            //       </div>
            //     </div>
            //   ),
            // },
            {
              title: 'input_opt_names',
              required: '',
              type: 'String[]',
              desc: '입력형옵션',
            },
            {
              title: 'opt_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  옵션구분
                  <ul style={{ color: 'gray' }}>
                    <li>
                      옵션명은 하나이지만 옵션값이 여러개일 경우도 조합형
                      옵션입니다.
                    </li>
                  </ul>
                  <div>
                    <div className='description' style={{ padding: '12px 0' }}>
                      Allowed values
                    </div>
                    <table>
                      <thead>
                        <tr>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong>
                              <code>옵션없음</code>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>조합형</code>
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ),
            },
            {
              title: 'opts',
              required: '',
              type: 'Object[]',
              desc: (
                <div>
                  옵션
                  <ul style={{ color: 'gray' }}>
                    <li>
                      옵션구분이 옵션없음 -{'>'} 조합형 으로 변경되는 경우, 필수
                      입력입니다.
                    </li>
                    <li>
                      옵션을 하나 이상 입력시, 전체 옵션은 입력된 옵션으로
                      대체됩니다.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'model_no',
              required: 'O',
              type: 'String(50)',
              desc: (
                <div>
                  Hmall 옵션 관리코드
                  <div className='description'>
                    (속성코드번호 + 옵션품목코드)
                  </div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'opt_sort1',
              required: 'O',
              type: 'String',
              desc: '옵션명1',
              indent: 1,
            },
            {
              title: 'opt_sort2',
              required: '',
              type: 'String',
              desc: '옵션명2',
              indent: 1,
            },
            {
              title: 'opt_sort3',
              required: '',
              type: 'String',
              desc: '옵션명3',
              indent: 1,
            },
            {
              title: 'opt_sort1_desc',
              required: 'O',
              type: 'String',
              desc: '옵션값1',
              indent: 1,
            },
            {
              title: 'opt_sort2_desc',
              required: '',
              type: 'String',
              desc: '옵션값2',
              indent: 1,
            },
            {
              title: 'opt_sort3_desc',
              required: '',
              type: 'String',
              desc: '옵션값3',
              indent: 1,
            },
            {
              title: 'add_price',
              required: '',
              type: 'Number',
              desc: '추가옵션금액',
              indent: 1,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Number',
              desc: '판매수량',
              indent: 1,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  옵션상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>정상</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>품절</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'madein',
              required: '',
              type: 'Object',
              desc: '원산지',
            },
            {
              title: 'madein_no',
              required: 'O',
              type: 'Number',
              desc: (
                <div>
                  원산지번호
                  <ul style={{ color: 'gray' }}>
                    <li>
                      <a href='/doc/원산지 조회' style={{ color: 'blue' }}>
                        원산지 조회{' '}
                      </a>
                      &nbsp;API 를 참고하여 작성해주세요.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'madein_etc',
              required: '',
              type: 'String',
              desc: (
                <div>
                  기타원산지
                  <ul style={{ color: 'gray' }}>
                    <li>
                      등록하려는 원산지가 origins 에서 조회되지 않을 때
                      madein_no 를 비우고 madein_etc 에 값을 입력합니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'tax_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  과세여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>과세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>면세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>영세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>비과세</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'ship_price_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  배송방법
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>무료</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>선결제</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>착불</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'ship_price',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  배송비
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>배송방법이 무료가 아닌경우 필수 입니다.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'ship_carr_no',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  배송 택배사코드
                  <ul style={{ color: 'gray' }}>
                    <li>
                      <a href='/doc/택배사 코드 조회' style={{ color: 'blue' }}>
                        택배사 코드 조회{' '}
                      </a>
                      &nbsp;API 로 확인한 택배사 코드를 작성해주세요.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'ship_leadtime',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '배송 소요일',
                sub: '1 ~ 14 사이의 값을 입력합니다.',
              }),
            },
            {
              title: 'prod_condition',
              required: '',
              type: 'String',
              desc: (
                <div>
                  상품 상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>new</code>
                          </strong>
                        </td>
                        <td>신상품</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>used</code>
                          </strong>
                        </td>
                        <td>중고상품</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'bundle_ship_avail_yn',
              required: '',
              type: 'Boolean',
              desc: '묶음배송 가능 여부',
            },
            {
              title: 'min_sale_qty_yn',
              required: '',
              type: 'Boolean',
              desc: '최소 구매수량 사용 여부',
            },
            {
              title: 'min_sale_qty',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  최소 구매수량
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>최소 구매수량 사용시 필수 입니다.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'max_sale_qty_yn',
              required: '',
              type: 'Boolean',
              desc: '최대 구매수량 사용 여부',
            },
            {
              title: 'max_sale_qty',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  최대 구매수량
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>최대 구매수량 사용시 필수 입니다.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'max_sale_qty_creteria',
              required: '',
              type: 'String',
              desc: (
                <div>
                  최대 구매수량 타입
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>최대 구매수량 사용시 필수 입니다.</li>
                  </ul>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>person</code>
                          </strong>
                        </td>
                        <td>구매자별 '수량 제한'</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>ord</code>
                          </strong>
                        </td>
                        <td>주문별 '1회 제한'</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'detail_desc',
              required: '',
              type: 'String',
              desc: '상품상세설명',
            },
            {
              title: 'sale_img1',
              required: '',
              type: 'String',
              desc: '기본이미지 URL',
            },
            {
              title: 'sale_img2',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '추가이미지 1 URL',
                sub: "이미지 삭제 = 'DELETE'",
              }),
            },
            {
              title: 'sale_img3',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '추가이미지 2 URL',
                sub: "이미지 삭제 = 'DELETE'",
              }),
            },
            {
              title: 'sale_img4',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '추가이미지 3 URL',
                sub: "이미지 삭제 = 'DELETE'",
              }),
            },
            {
              title: 'sale_img5',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '추가이미지 4 URL',
                sub: "이미지 삭제 = 'DELETE'",
              }),
            },
            {
              title: 'sale_img6',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '추가이미지 5 URL',
                sub: "이미지 삭제 = 'DELETE'",
              }),
            },
            {
              title: 'sale_img7',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '추가이미지 6 URL',
                sub: "이미지 삭제 = 'DELETE'",
              }),
            },
            {
              title: 'sale_img8',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '추가이미지 7 URL',
                sub: "이미지 삭제 = 'DELETE'",
              }),
            },
            {
              title: 'sale_img9',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '추가이미지 8 URL',
                sub: "이미지 삭제 = 'DELETE'",
              }),
            },
            {
              title: 'sale_img10',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '추가이미지 9 URL',
                sub: "이미지 삭제 = 'DELETE'",
              }),
            },
            {
              title: 'sale_img11',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '추가이미지 10 URL',
                sub: "이미지 삭제 = 'DELETE'",
              }),
            },
            {
              title: 'prod_info',
              required: '',
              type: 'Object[]',
              desc: (
                <div>
                  상품정보제공고시
                  <br />
                  <ul className='style no-margin' style={{ color: 'gray' }}>
                    <li>품목정보고시정보는 3개까지 입력가능합니다.</li>
                    <li>아래의 등록가이드를 참고해주세요.</li>
                    <li>
                      <a
                        href='https://gmp-master.s3.ap-northeast-2.amazonaws.com/download/Sample_prodInfo_guide_OPENAPI.xlsx'
                        style={{ color: 'blue' }}
                      >
                        상품 품목정보고시 가이드 개정판
                      </a>
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'infoCode',
              required: 'O',
              type: 'String',
              desc: '상품분류코드',
              indent: 1,
            },
            {
              title: 'infoDetail',
              required: 'O',
              type: 'object',
              desc: (
                <div>
                  상품 정보 제공고시 데이터
                  <ul style={{ color: 'gray' }}>
                    <li>
                      품목 정보고시 가이드에 기재된 각 항목에 따른 key와 value를
                      입력합니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'is_desc_referred',
              type: 'boolean',
              desc: (
                <div>
                  상품 정보 제공고시 데이터 일괄 [상세설명참조] 적용
                  <ul style={{ color: 'gray' }}>
                    <li>
                      해당 값을 <code>true</code> 로 설정 시 입력한 값과 상관
                      없이 일괄 <code>[상세설명참조]</code>로 적용됩니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'brand',
              required: '',
              type: 'String',
              desc: '브랜드',
            },
            {
              title: 'model',
              required: '',
              type: 'String',
              desc: '모델명',
            },
            {
              title: 'maker',
              required: '',
              type: 'String',
              desc: '제조사',
            },
            {
              title: 'adult_yn',
              required: '',
              type: 'Boolean',
              desc: (
                <div>
                  미성년자 구매여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>true</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'made_date',
              required: '',
              type: 'String',
              desc: (
                <div>
                  제조일자
                  <ul style={{ color: 'gray' }}>
                    <li>YYYY-MM-DD의 날짜형식으로 입력해주십시오.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'expire_date',
              required: '',
              type: 'String',
              desc: (
                <div>
                  유효일자
                  <ul style={{ color: 'gray' }}>
                    <li>YYYY-MM-DD의 날짜형식으로 입력해주십시오.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'keywords',
              required: '',
              type: 'String[]',
              desc: (
                <div>
                  키워드
                  <br />
                  <ul style={{ color: 'gray' }}>
                    <li>
                      키워드는 최대 40개 까지 등록가능하며, 쇼핑몰에 상품전송시
                      쇼핑몰에서 지원하는 입력 갯수만큼만 전송됩니다.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'supply_price',
              required: '',
              type: 'Number',
              desc: '공급가',
            },
            {
              title: 'cost_price',
              required: '',
              type: 'Number',
              desc: '원가',
            },
            {
              title: 'street_price',
              required: '',
              type: 'Number',
              desc: '시중가',
            },
            {
              title: 'gift_name',
              required: '',
              type: 'String',
              desc: '사은품',
            },
            {
              title: 'isbn',
              required: '',
              type: 'Number',
              desc: 'ISBN 코드',
            },
            {
              title: 'barcode',
              required: '',
              type: 'String',
              desc: '바코드',
            },
            {
              title: 'hscd',
              required: '',
              type: 'String',
              desc: 'HS코드',
            },
            {
              title: 'global_barcode_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  UPC/EAN 타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>UPC</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>EAN</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'global_barcode',
              required: '',
              type: 'Number',
              desc: 'UPC/EAN 코드',
            },
            {
              title: 'prod_weight',
              required: '',
              type: 'Number',
              desc: '상품무게',
            },
            {
              title: 'cert_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  인증정보타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>인증대상아님</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>인증유형등록</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>인증대상아님</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>상세설명내등록</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'certs',
              required: '',
              type: 'Object[]',
              desc: (
                <div>
                  인증정보
                  <br />
                  <ul className='style no-margin' style={{ color: 'gray' }}>
                    <li>인증정보는 10개까지 등록 가능합니다.</li>
                    <li>
                      인증정보타입이 인증유형등록인 경우 필수로 입력해주셔야
                      합니다.
                    </li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'cert_cd',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  인증유형
                  <br />
                  <ul className='style no-margin' style={{ color: 'gray' }}>
                    <li>cert_01: 생활용품 안전인증</li>
                    <li>cert_02: 생활용품 안전확인</li>
                    <li>cert_03: 생활용품 어린이보호포장</li>
                    <li>cert_04: 생활용품 안전품질표시</li>
                    <li>cert_05: 생활용품 공급자적합성확인</li>
                    <li>cert_06: 전기용품 안전인증</li>
                    <li>cert_07: 전기용품 안전확인</li>
                    <li>cert_08: 전기용품 공급자적합성확인</li>
                    <li>cert_09: 방송통신용품 적합성인증확인</li>
                    <li>cert_10: 어린이제품 안전인증</li>
                    <li>cert_11: 어린이제품 안전확인</li>
                    <li>cert_12: 어린이제품 공급자적합성확인</li>
                    <li>cert_13: 위해우려제품 자가검사</li>
                    <li>cert_14: 방송통신기자재 잠정인증</li>
                    <li>cert_15: 방송통신기자재 적합등록</li>
                    <li>cert_16: 원산지증명</li> <li>cert_17: 해외안전인증</li>
                    <li>cert_18: 수입신고필증</li>
                    <li>cert_19: 친환경인증-무농약농산물</li>
                    <li>cert_20: 친환경인증-유기축산물</li>
                    <li>cert_21: 친환경인증-유기농산물</li>
                    <li>cert_22: 친환경인증-저농약농산물</li>
                    <li>cert_23: 친환경인증-무항생제축산물</li>
                    <li>cert_24: HACCP(위해요소 중점관리우수식품)</li>
                    <li>cert_25: GMP(우수건강기능식품 제조기준)</li>
                    <li>cert_26: GAP(농산물우수관리인증)</li>
                    <li>cert_27: 농산물이력추적관리</li>
                    <li>cert_28: 수산물품질인증</li>
                    <li>cert_29: 수산특산물품질인증</li>
                    <li>cert_30: 수산전통식품품질인증</li>
                    <li>cert_31: 친환경수산물품질인증</li>
                    <li>cert_32: 친환경수산가공품품질인증</li>
                    <li>cert_33: 전통식품 품질인증</li>
                    <li>cert_34: 유기가공식품 인증</li>
                    <li>cert_35: 가공식품 산업표준 KS인증</li>
                    <li>cert_36: 건강기능식품 광고사전심의</li>
                    <li>cert_37: 의료기기 광고사전심의</li>
                    <li>cert_38: 축산물 등급판정 확인서</li>
                    <li>cert_39: 도축검사증명서</li>
                    <li>cert_40: 식품명인(Grand master) 인증</li>
                    <li>cert_41: 사회적기업 인증</li>
                    <li>cert_42: 6차산업 인증</li>
                    <li>cert_43: 동물복지 인증</li>
                    <li>cert_44: 마을기업 인증</li>
                    <li>cert_45: 건강기능식품인증</li>
                    <li>cert_46: 생활화학제품</li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'cert_exc_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  면제유형
                  <br />
                  <ul className='style' style={{ color: 'gray' }}>
                    <li>kc_01: 안전기준준수대상</li>
                    <li>kc_02: 구매대행</li>
                    <li>kc_03: 병행수입</li>
                  </ul>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>kc_01</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>kc_02</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>kc_03</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'cert_ministry',
              required: '',
              type: 'String',
              desc: '인증기관',
              indent: 1,
            },
            {
              title: 'cert_no',
              required: 'O',
              type: 'String',
              desc: '인증번호',
              indent: 1,
            },
            {
              title: 'cert_model',
              required: '',
              type: 'String',
              desc: '인증모델',
              indent: 1,
            },
            {
              title: 'cert_cname',
              required: '',
              type: 'String',
              desc: '인증상호',
              indent: 1,
            },
            {
              title: 'cert_date',
              required: '',
              type: 'String',
              desc: (
                <div>
                  인증일
                  <ul style={{ color: 'gray' }}>
                    <li>YYYY-MM-DD의 날짜형식으로 입력해주십시오.</li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'cert_expire_date',
              required: '',
              type: 'String',
              desc: (
                <div>
                  인증만료일
                  <ul style={{ color: 'gray' }}>
                    <li>YYYY-MM-DD의 날짜형식으로 입력해주십시오.</li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
          ],
          body_example: {
            c_sale_cd: 374200041,
            shop_sale_name: 'api 테스트 판매가를 수정하자',
            sale_price: 60000,
            street_price: 100000,
            opt_type: '조합형',
            opts: [
              {
                model_no: '00001-00001',
                opt_sort1: '색상',
                opt_sort2: '',
                opt_sort3: '',
                opt_sort1_desc: '빨강',
                opt_sort2_desc: '',
                opt_sort3_desc: '',
                add_price: 0,
                stock_cnt: 999,
                status: '정상',
              },
              {
                model_no: '00001-00002',
                opt_sort1: '색상',
                opt_sort2: '',
                opt_sort3: '',
                opt_sort1_desc: '파랑',
                opt_sort2_desc: '',
                opt_sort3_desc: '',
                add_price: 10000,
                stock_cnt: 999,
                status: '정상',
              },
            ],
            ship_carr_no: 4,
            ship_leadtime: 2,
            prod_condition: 'used',
            bundle_ship_avail_yn: false,
            min_sale_qty_yn: true,
            min_sale_qty: 2,
            max_sale_qty_yn: false,
            detail_desc: '상세설명도 수정하자',
          },
          response: [
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: '성공/실패',
            },
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'String',
              desc: '수정된 온라인상품 고유번호',
            },
            {
              title: 'error_code',
              required: 'O',
              type: 'String',
              desc: '수정이 실패된 경우 에러코드',
            },
            {
              title: 'messages',
              required: 'O',
              type: 'String[]',
              desc: '수정이 실패된 경우 에러메시지',
            },
          ],
          response_example: {
            result: '성공',
            ol_shop_no: 374200041,
          },
        },
      ],
    },
    {
      title: '온라인상품 판매수량 수정',
      url: '/doc/Hmall/온라인상품 판매수량 수정',
      data: [
        {
          version: 'hmall',
          url: '/products/sale-cnt/hmall',
          desc: (
            <ul className='style'>
              <li>
                온라인상품의 쇼핑몰판매수량 및 등록된 옵션정보의 판매수량을
                수정합니다.
              </li>
            </ul>
          ),
          method: 'PATCH',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'products',
              required: 'O',
              type: 'Object[]',
              desc: '상품정보',
            },
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'Number(10)',
              desc: '온라인상품 고유번호',
              indent: 1,
            },
            {
              title: 'sale_cnt_limit',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  쇼핑몰 판매수량
                  <div className='description'>(상품정보)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'opts',
              required: '',
              type: 'Object[]',
              desc: '상품 옵션정보',
              indent: 1,
            },
            {
              title: 'model_no',
              required: 'O',
              type: 'String(50)',
              desc: (
                <div>
                  Hmall 옵션 관리코드
                  <div className='description'>
                    (속성코드번호 + 옵션품목코드)
                  </div>
                </div>
              ),
              indent: 2,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Number',
              desc: '옵션 판매수량',
              indent: 2,
            },
            {
              title: 'status',
              required: '',
              type: 'String',
              desc: (
                <div>
                  옵션 상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>정상</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>품절</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 2,
            },
          ],
          body_example: {
            products: [
              {
                ol_shop_no: 374200041,
                opts: [
                  {
                    model_no: '00001-00002',
                    stock_cnt: 999,
                    status: '정상',
                  },
                ],
              },
              {
                ol_shop_no: 374200103,
                sale_cnt_limit: 500,
              },
            ],
          },
          response: [
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'Number(10)',
              desc: '온라인상품 고유번호',
            },
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  성공 또는 실패
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>성공</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>실패</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'message',
              required: 'O',
              type: 'String',
              desc: '실패시 에러메세지',
            },
          ],
          response_example: [
            {
              ol_shop_no: 374200041,
              result: '성공',
              message: '',
            },
            {
              ol_shop_no: 374200103,
              result: '실패',
              message: '상품정보가 조회되지 않습니다.',
            },
          ],
        },
      ],
    },
    {
      title: '온라인상품 연동 수정/해제',
      url: '/doc/Hmall/온라인상품 연동 수정',
      data: [
        {
          version: 'hmall',
          url: '/products/shop-linkage/hmall',
          method: 'PATCH',
          desc: (
            <ul className='style'>
              <li>
                온라인 상품의 쇼핑몰 상품코드를 직접 입력하여 쇼핑몰 연동 정보를
                변경합니다.
              </li>
              <li>
                온라인상품에 해당 쇼핑몰의 판매중인 상품번호 또는 상품코드를
                입력합니다.
              </li>
              <li>
                <div style={{ color: 'red' }}>
                  솔루션의 상태만 변경되고 실제 쇼핑몰의 상태는 변경되지
                  않습니다.
                </div>
              </li>
            </ul>
          ),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'type',
              required: 'O',
              type: 'string',
              desc: (
                <div>
                  연동 방식 선택
                  <ul className='style' style={{ color: 'gray' }}>
                    <li>
                      edit: 연동 수정 (쇼핑몰 상품 코드를 입력하며 해당 상품의
                      상태를 판매중으로 변경)
                    </li>
                    <li>
                      stop: 연동 해제 (쇼핑몰 상품 코드를 삭제하며 해당 상품의
                      상태를 판매대기로 변경)
                    </li>
                  </ul>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>edit</code>
                          </strong>
                        </td>
                        <td>연동 수정</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>stop</code>
                          </strong>
                        </td>
                        <td>연동 해제</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'products',
              required: 'O',
              type: 'Object[]',
              desc: '연동할 상품 데이터',
            },
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'Number(10)',
              desc: '온라인상품 고유번호',
              indent: 1,
            },
            {
              title: 'shop_sale_no',
              required: 'O',
              type: 'String',
              desc: '연동할 쇼핑물 상품코드',
              indent: 1,
            },
            {
              title: 'playauto_cate_no',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  플레이오토 카테고리 번호
                  <ul style={{ color: 'gray' }}>
                    <li>연동 수정시에만 사용 가능합니다.</li>
                    <li>
                      기존 상품의 쇼핑몰 카테고리를 변경할 때에만 사용합니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'shop_cate_info',
              required: '',
              type: 'Object',
              desc: (
                <div>
                  개별 카테고리 정보
                  <ul style={{ color: 'gray' }}>
                    <li>카페24(신) 연동 수정시에만 사용 가능합니다.</li>
                    <li>
                      기존 상품의 쇼핑몰 카테고리를 변경할 때에만 사용합니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'code',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  카테고리 코드
                  <ul style={{ color: 'gray' }}>
                    <li>
                      'lcate01_mcate02_scate01_dcate04' 와 같이 대분류부터 전체
                      코드를 '_' 기호로 합쳐서 넣어주세요.
                    </li>
                  </ul>
                </div>
              ),
              indent: 2,
            },
            {
              title: 'name',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  카테고리 명
                  <ul style={{ color: 'gray' }}>
                    <li>
                      '패션{'>'}여성의류{'>'}하의{'>'}치마' 와 같이 대분류부터
                      전체 코드를 '{'>'}' 기호로 합쳐서 넣어주세요.
                    </li>
                  </ul>
                </div>
              ),
              indent: 2,
            },
            {
              title: 'template_no',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  쇼핑몰 템플릿 번호
                  <ul style={{ color: 'gray' }}>
                    <li>연동 수정시에만 사용 가능합니다.</li>
                    <li>
                      기존 상품의 템플릿 정보를 변경할 때에만 사용합니다. (참고.
                      연동 해제 시 템플릿 정보는 삭제됩니다.)
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
          ],
          body_example: {
            type: 'edit',
            products: [
              {
                ol_shop_no: 69224645,
                shop_sale_no: '1111111111',
                playauto_cate_no: 123,
              },
              {
                ol_shop_no: 69224646,
                shop_sale_no: '2222222222',
                template_no: 2252130,
              },
            ],
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Object[]',
              desc: '결과값',
            },
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'Number',
              desc: '온라인상품 고유번호',
              indent: 1,
            },
            {
              title: 'shop_sale_no',
              required: 'O',
              type: 'String',
              desc: '연동 수정/해제 쇼핑물 상품코드',
              indent: 1,
            },
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  성공 또는 실패
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>성공</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>실패</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'message',
              required: 'O',
              type: 'String',
              desc: '실패시 에러메세지',
              indent: 1,
            },
          ],
          response_example: [
            {
              results: [
                {
                  ol_shop_no: 69224645,
                  shop_sale_no: '1111111111',
                  result: '실패',
                  message: '플레이오토 카테고리 번호를 확인해주세요.(123)',
                },
                {
                  ol_shop_no: 69224646,
                  shop_sale_no: '2222222222',
                  result: '성공',
                  message: '',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: '템플릿 정보 조회',
      url: '/doc/Hmall/템플릿 정보 조회',
      data: [
        {
          version: 'hmall',
          url: '/template-info/hmall',
          desc: (
            <ul className='style'>
              <li>
                각 쇼핑몰마다 요구하는 상품 정보 형식이 다르기 때문에 쇼핑몰
                상품연동시 템필릿 정보는 필수로 입력해야 합니다.
              </li>
              <li>
                템플릿 정보를 통해 쇼핑몰별 필수 항목과 형식에 맞춰 상품 정보를
                구성할 수 있습니다.
              </li>
            </ul>
          ),
          method: 'POST',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 코드',
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 계정',
            },
          ],
          body_example: {
            shop_cd: 'A538',
            shop_id: 'playauto',
          },
          response: [
            {
              title: 'data',
              required: 'O',
              type: 'boolean',
              desc: '템플릿 설정 정보',
            },
            {
              title: 'error_code',
              required: 'O',
              type: 'String',
              desc: '조회가 실패된 경우 에러코드',
            },
            {
              title: 'messages',
              required: 'O',
              type: 'String[]',
              desc: '조회가 실패된 경우 에러메시지',
            },
          ],
          response_example: {
            data: '// 템플릿 정보는 쇼핑몰마다 상이하여 예시를 제공하지 않습니다.',
          },
        },
      ],
    },
    {
      title: '템플릿 등록/수정',
      url: '/doc/Hmall/템플릿 등록/수정',
      data: [
        {
          version: 'hmall',
          url: '/product/template/hmall',
          desc: (
            <ul className='style'>
              <li>쇼핑몰의 템플릿 정보를 API 를 통해 등록/수정합니다.</li>
              <li>
                <a href='/doc/Hmall/템플릿 정보 조회' style={{ color: 'blue' }}>
                  템플릿 정보 조회{' '}
                </a>
                API를 통해 템플릿 등록 형식을 확인할 수 있습니다.
              </li>
            </ul>
          ),
          method: 'POST',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 코드',
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 계정',
            },
            {
              title: 'name',
              required: 'O',
              type: 'String(80)',
              desc: '템플릿 명',
            },
            {
              title: 'template_data',
              required: 'O',
              type: 'Object',
              desc: '템플릿 정보',
            },
            {
              title: 'template_no',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  템플릿 번호
                  <ul style={{ color: 'gray' }}>
                    <li>미입력시 템플릿을 신규로 등록합니다.</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'is_update_status',
              required: '',
              type: 'Boolean',
              desc: (
                <div>
                  템플릿 수정시 해당 템플릿이 적용된 온라인 상품의 상태의
                  수정대기로 변경 여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>false</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
          ],
          body_example: {
            shop_cd: 'A538',
            shop_id: 'playauto',
            name: '토스쇼핑 템플릿1',
            template_data: {
              key_deliveryFee: '3000',
              key_deliveryMethod: 'NORMAL',
              key_jejuDeliveryFee: '5000',
            },
          },
          response: [
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: '성공',
            },
            {
              title: 'template_no',
              required: 'O',
              type: 'Number',
              desc: '등록/수정된 템플릿 번호',
            },
            {
              title: 'error_code',
              required: 'O',
              type: 'String',
              desc: '실패된 경우 에러코드',
            },
            {
              title: 'messages',
              required: 'O',
              type: 'String[]',
              desc: '실패된 경우 에러메시지',
            },
          ],
          response_example: {
            result: '성공',
            template_no: 2252130,
          },
          error_example: {
            error_code: 'e4999',
            messages: ['템플릿 엔진 등록 실패'],
          },
        },
      ],
    },
    {
      title: '템플릿 상세 조회',
      url: '/doc/Hmall/템플릿 상세 조회',
      data: [
        {
          version: 'hmall',
          url: '/product/template/:template_no/hmall',
          desc: '솔루션에 등록된 온라인상품 템플릿 정보를 조회합니다.',
          method: 'GET',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'template_no',
              required: '',
              type: 'Number',
              desc: '템플릿 번호',
            },
          ],
          response: [
            {
              title: 'template_no',
              required: 'O',
              type: 'Number',
              desc: '템플릿 번호',
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String(4)',
              desc: '쇼핑몰 코드',
            },
            {
              title: 'shop_name',
              required: 'O',
              type: 'String(50)',
              desc: '쇼핑몰 명',
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String(40)',
              desc: '쇼핑몰 계정 아이디',
            },
            {
              title: 'name',
              required: 'O',
              type: 'String(80)',
              desc: '템플릿명',
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  템플릿 등록일
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
            },
            {
              title: 'mdate',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  템플릿 수정일
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
            },
            {
              title: 'apply_prod_cnt',
              required: 'O',
              type: 'Number',
              desc: '템플릿이 적용되어있는 온라인 상품 수',
            },
            {
              title: 'register_name',
              required: 'O',
              type: 'String',
              desc: '등록자',
            },
            {
              title: 'template_data',
              required: 'O',
              type: 'Object',
              desc: '템플릿 정보',
            },
          ],
          response_example: {
            template_no: 2252130,
            shop_cd: 'A538',
            shop_name: '토스 쇼핑',
            shop_id: 'playauto',
            name: '토스쇼핑 템플릿1',
            wdate: '2026-02-12 19:16:55',
            mdate: '2026-02-20 16:03:08',
            apply_prod_cnt: 4,
            register_name: '올리비아',
            template_data: {},
          },
          error_example: {
            error_code: 'e4016',
            messages: ['존재하지 않는 템플릿입니다.'],
          },
        },
      ],
    },
    {
      title: '템플릿 삭제',
      url: '/doc/Hmall/템플릿 삭제',
      data: [
        {
          version: 'hmall',
          url: '/product/templates/hmall',
          desc: '솔루션에 등록된 온라인상품 템플릿을 삭제합니다.',
          method: 'DELETE',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'templates',
              required: 'O',
              type: 'Number[]',
              desc: (
                <div>
                  템플릿 번호 리스트
                  <ul className='style' style={{ color: 'gray' }}>
                    <li>
                      일괄 삭제는 최대 100개 까지 가능하며, 템플릿이 적용된
                      온라인 상품이 존재하는 경우 실패됩니다.
                    </li>
                  </ul>
                </div>
              ),
            },
          ],
          response: [
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: '성공',
            },
            {
              title: 'templates',
              required: 'O',
              type: 'Number[]',
              desc: '삭제된 템플릿 번호 리스트',
            },
            {
              title: 'error_code',
              required: 'O',
              type: 'String',
              desc: '실패된 경우 에러코드',
            },
            {
              title: 'messages',
              required: 'O',
              type: 'String[]',
              desc: '실패된 경우 에러메시지',
            },
          ],
          response_example: {
            result: '성공',
            templates: [2252130],
          },
          error_example: {
            error_code: 'e4999',
            messages: ['선택한 템플릿으로 등록한 온라인 상품이 존재합니다.'],
          },
        },
      ],
    },
    {
      title: '템플릿 배송지 등록/수정',
      url: '/doc/Hmall/템플릿 배송지 등록/수정',
      data: [
        {
          version: 'hmall',
          url: '/template-info/logistics-location/hmall',
          desc: (
            <ul className='style'>
              <li>
                쇼핑몰의 출고지, 교환/반품지 와 같은 배송지 정보를 API 를 통해
                등록/수정합니다.
              </li>
              <li>
                템플릿 생성시 배송지를 지정할 수 있으며,{' '}
                <a href='/doc/Hmall/템플릿 정보 조회' style={{ color: 'blue' }}>
                  템플릿 정보 조회{' '}
                </a>
                API를 통해 배송지 정보를 확인할 수 있습니다.
              </li>
              <li>현재 '토스쇼핑'만 교환/반품지 등록/수정을 지원합니다.</li>
            </ul>
          ),
          method: 'POST',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 코드',
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 계정',
            },
            {
              title: 'logistics_location_name',
              required: 'O',
              type: 'String',
              desc: '배송지 명',
            },
            {
              title: 'zip_code',
              required: 'O',
              type: 'String',
              desc: '배송지 우편번호',
            },
            {
              title: 'address',
              required: 'O',
              type: 'String',
              desc: '배송지 주소',
            },
            {
              title: 'detail_address',
              required: 'O',
              type: 'String',
              desc: '배송지 상세주소',
            },
            // 일단 현재 지원중인 쇼핑몰엔 불필요한 값으로 노출 안함
            // {
            //   title: 'phone',
            //   required: '',
            //   type: 'String',
            //   desc: '전화번호',
            // },
            // {
            //   title: 'cell_phone',
            //   required: '',
            //   type: 'String',
            //   desc: '휴대폰번호',
            // },
            {
              title: 'is_main',
              required: '',
              type: 'Boolean',
              desc: (
                <div>
                  대표(기본) 배송지 여부
                  <ul style={{ color: 'gray' }}>
                    <li>일부 쇼핑몰의 경우 필수 항목입니다. (ex. 토스쇼핑)</li>
                  </ul>
                </div>
              ),
            },
            {
              title: 'logistics_location_id',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  배송지 ID
                  <ul style={{ color: 'gray' }}>
                    <li>
                      미입력시 쇼핑몰에 배송지(출고지, 교환/반품지)를 신규로
                      등록합니다.
                    </li>
                  </ul>
                </div>
              ),
            },
          ],
          body_example: {
            shop_cd: 'A538',
            shop_id: 'playauto',
            logistics_location_name: 'playauto 교환반품지1',
            zip_code: '08390',
            address: '서울특별시 구로구 디지털로26길 123',
            detail_address: '지플러스타워 14층 플레이오토',
            is_main: false,
          },
          response: [
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: '성공|실패',
            },
            {
              title: 'logistics_location_id',
              required: 'O',
              type: 'Number',
              desc: '등록/수정된 배송지 ID',
            },
            {
              title: 'error_code',
              required: 'O',
              type: 'String',
              desc: '실패된 경우 에러코드',
            },
            {
              title: 'messages',
              required: 'O',
              type: 'String[]',
              desc: '실패된 경우 에러메시지',
            },
          ],
          response_example: {
            result: '성공',
            logistics_location_id: 501419,
          },
        },
      ],
    },
    {
      title: '배송그룹(Toss) 등록/수정',
      url: '/doc/Hmall/배송그룹 등록/수정',
      data: [
        {
          version: 'hmall',
          url: '/template-info/delivery-group/hmall',
          desc: (
            <ul className='style'>
              <li>
                토스쇼핑의 '배송 묶음 그룹' 을 API 를 통해 등록/수정합니다.
              </li>
              <li>
                토스쇼핑 상품연동시 묶음 그룹끼리 합배송할 수 있는 '배송 묶음
                그룹'을 필수로 입력해야 합니다.
              </li>
              <li>
                템플릿 생성시 '배송 묶음 그룹' 을 지정할 수 있으며,{' '}
                <a href='/doc/Hmall/템플릿 정보 조회' style={{ color: 'blue' }}>
                  템플릿 정보 조회{' '}
                </a>
                API를 통해 '배송 묶음 그룹' 정보를 확인할 수 있습니다.
              </li>
            </ul>
          ),
          method: 'POST',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 코드',
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 계정',
            },
            {
              title: 'delivery_group_name',
              required: 'O',
              type: 'String',
              desc: '묶음 그룹명',
            },
            {
              title: 'is_main',
              required: 'O',
              type: 'Boolean',
              desc: '대표(기본) 묶음 그룹 여부',
            },
            {
              title: 'delivery_group_id',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  묶음 그룹 ID
                  <ul style={{ color: 'gray' }}>
                    <li>미입력시 묶음 그룹을 신규로 등록합니다.</li>
                  </ul>
                </div>
              ),
            },
          ],
          body_example: {
            shop_cd: 'A538',
            shop_id: 'playauto',
            delivery_group_name: 'playauto 묶음그룹1',
            is_main: false,
          },
          response: [
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: '성공|실패',
            },
            {
              title: 'delivery_group_id',
              required: 'O',
              type: 'Number',
              desc: '등록/수정된 묶음 그룹 ID',
            },
            {
              title: 'error_code',
              required: 'O',
              type: 'String',
              desc: '실패된 경우 에러코드',
            },
            {
              title: 'messages',
              required: 'O',
              type: 'String[]',
              desc: '실패된 경우 에러메시지',
            },
          ],
          response_example: {
            result: '성공',
            delivery_group_id: 501417,
          },
        },
      ],
    },
  ],
});

export default data;
